import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import themes from 'devextreme/ui/themes';
import {MatExpansionModule} from '@angular/material/expansion';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {MatFormFieldModule} from '@angular/material/form-field';
import {
  DxActionSheetModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxContextMenuModule,
  DxDataGridComponent,
  DxDataGridModule,
  DxDropDownButtonModule,
  DxFormModule,
  DxPopoverModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSwitchModule,
  DxTabsModule,
  DxTextBoxModule,
  DxToolbarModule
} from 'devextreme-angular';
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver';
import {ColumnModel, ColumnTypes, Format, OtherButtons, SumListItem, SumModel} from '../../models/dx-data-table.model';
import {locale} from 'devextreme/localization';
import {formatMessage} from 'devextreme/localization'; // DKM-5052 Clara
import config from 'devextreme/core/config';
import {UserProcessData,} from '../../layouts/main/forms-footer/forms-footer.component';
import {OrtakService} from '../../services/ortak.service';
import {GridsEditMode, PagerDisplayMode} from 'devextreme/common/grids';
import {
  ButtonWithIconObject,
  CURRENCY_EXCEL_FORMAT,
  CURRENCY_FORMAT,
  DataCoreService,
  DlistDto,
  DonemKontrolObject,
  DxGridColumnDto,
  DynamicButton,
  FormAction_Request,
  FormDto, FormMetadataService,
  FormYetkiDto,
  GenPivotGridComponent,
  GridConditionModel, GridConditionModelForColumnCss,
  GridConditionModelForCss,
  GridHeaderConditionModelForCss,
  ScreenService,
  SetDlist_Request,
  UtilsService
} from "@dabnet-kamu/libs/ui";
import {HistoryComponent, HistoryFilterData} from '../history/history.component'
import {FormsModule} from "@angular/forms";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {AuthService} from "../../../../../../auth/src/lib/auth.service";
import {CellTemplate} from '../../constants/cellTemplate';
import {
  ContentReadyEvent,
  DataGridScrollMode,
  DataType,
  EditingStartEvent,
  HorizontalEdge,
  OptionChangedEvent,
  RowInsertedEvent,
  RowInsertingEvent,
  RowRemovingEvent,
  RowUpdatingEvent
} from 'devextreme/ui/data_grid';
import {filter, firstValueFrom, take} from 'rxjs';
import {CellTemplatePipe} from '../../pipes/cell-template/cell-template.pipe';
import {EditCellTemplatePipe} from '../../pipes/edit-cell-template/edit-cell-template.pipe';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ArialBase64} from '../../fonts/arial';
import {confirm} from "devextreme/ui/dialog";
import {ValueChangedEvent} from 'devextreme/ui/switch';
import {GenPivotGridService} from '../gen-pivot-grid/gen-pivot-grid.service';
import {GridBottomToolbarComponent} from "../headers/grid-bottom-toolbar/grid-bottom-toolbar.component";
import {GenDlist} from "../../../../../../gen/src/lib/models/gen.models";
import {DListService} from "../../../../../../ys/src/lib/components/DList/DList.service";
import { LocateInMenuMode } from 'devextreme/ui/toolbar';

/** DKM-5296: dışa aktarımdaki alt toplam hücresi (plain: displayFormat sadece '{0}' → Excel'e sayı yazılır) */
interface ExportToplamHucre {
  value: number;
  text: string;
  plain: boolean;
}

@Component({
  selector: 'dk-dx-data-table2',
  templateUrl: './dk-dx-data-ctl-table.component.html',
  styleUrls: ['./dk-dx-data-ctl-table.component.scss'],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxToolbarModule,
    DxFormModule,
    DxButtonModule,
    DxCheckBoxModule,
    DxPopupModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    DxTabsModule,
    DxScrollViewModule,
    CommonModule,
    DxSwitchModule,
    DxPopoverModule,
    DxContextMenuModule,
    DxActionSheetModule,
    FormsModule,
    DxDropDownButtonModule,
    forwardRef(() => HistoryComponent),
    CellTemplatePipe,
    EditCellTemplatePipe,
    GenPivotGridComponent,
    GridBottomToolbarComponent,
    DxTextBoxModule,
  ],
})
export class DkDxDataCtlTableComponent
  implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('gridSettingsContainer', {read: ViewContainerRef}) gridSettingsContainer: ViewContainerRef;

  private gridSettingsComponentRef: ComponentRef<any>;

  @ViewChild(DxDataGridComponent, {static: false}) dataGrid: DxDataGridComponent;
  @Input() dropdownConfig!: {
    items: any[];
    selectedItemKey: any;
    styLingMode?: string;
    type?: string;
    displayExpr?: string;
    keyExpr?: string;
  };

  @Input() public dataSource!: any;
  @Input() public columnValidationRules!: any;
  @Input() public donemAktif = true;
  @Input() public donemKontrolObject: DonemKontrolObject;
  @Input() public keyExpr!: string;
  @Input() public dragingKeyExpr!: string;
  @Input() public dragingTableName!: string;
  @Input() public tableTittle!: string;
  @Input() public dListName!: string;
  @Input() public formMetaData!: FormDto;
  @Input() defaultValues: { [key: string]: any };
  @Input() deleteBeforeSave!: any[];
  @Input() public tableAddNewButton?: {
    newButtonText: string;
    disable?: boolean;
    icon?: string;
  };
  @Input() otherActionBtnList: ButtonWithIconObject[];
  @Input() rightClickActions!: any[];
  @Input() inlineMenuActions!: ButtonWithIconObject[];
  @Input() dynamicTableHeaderButtons!: any[];
  @Input() tableHeaderSwitchButton!: string;
  @Input() customTableHeaderSwitchButton!: string;
  @Input() customTableHeaderSwitchButtonValue: boolean;
  @Input() isGroupingYn = true;
  @Input() public columnList!: ColumnModel[];
  @Input() public summaryVersion: string = 'total';
  @Input() public setChangeWarning: boolean = false;
  @Input() public displayBottomChevron: boolean = false;
  @Input() public sumList!: SumModel[];
  @Input() public sumListItems!: SumListItem[];
  @Input() public columnTransactions = true;
  @Input() public gridCtlList!: DlistDto;
  @Input() public columnHidingEnabled = true;
  @Input() public isUserProcessFooter = true;
  @Input() public inlineCellEdit = false;
  @Input() public baseTable = false;
  @Input() public showBorders = true;
  @Input() public editWithDblClick = true;
  @Input() public editingMode!: GridsEditMode
  /** editingMode 'popup' iken açılan düzenleme popup'ının başlığı / genişliği */
  @Input() public popupEditTitle: string;
  @Input() public popupEditWidth: number | string = 700;
  @Input() public batchEditing: boolean = false;
  /**
   * Batch modda satıra tıklamak zaten hücreyi düzenlemeye açıyor - popup açan ayrı
   * bir "Düzenle" ikonu isteyen gridler bunu true geçer. Kendi başına, tek bir
   * "İşlemler" kolonu (Düzenle+Sil+Geçmiş) üretir; backend dlist'in columnList'e
   * bastığı 'İşlemler' item'ının type'ına (editButtonColumn/deleteButtonColumn/...)
   * bağlı DEĞİLDİR - o item'in üretimi OrtakService.setRecursiveFieldData'daki
   * paylaşılan/instance-level mutable state (this.type/this.mode) yüzünden
   * güvenilir değil (aynı ngOnChanges içinde art arda çağrılan farklı dlist'ler
   * birbirinin sonucunu etkileyebiliyor - kalem ikonu "bazen görünüyor bazen
   * kayboluyor" şikayeti buradan geldi). Bu true iken backend-güdümlü 'custom'
   * editMode bloğu devre dışı kalır (bkz. şablon), iki kez "İşlemler" görünmesin.
   */
  @Input() public showBatchEditButton: boolean = false;
  /**
   * true/false ise tüm satırlara uygulanır. Satır bazlı kısıtlama gereken
   * gridlerde (ör. GenSorguKolon'da kendi EditYn'i false olan satırlar
   * kilitli kalsın diye) fonksiyon geçilebilir - DevExtreme'in
   * dxo-editing.allowUpdating'i zaten boolean|Function kabul ediyor, buraya
   * gelen değer aynen ona iletiliyor (bkz. şablondaki allowUpdating binding'i).
   */
  @Input() public batchEditingAllowUpdating: boolean | ((e: any) => boolean) = true;
  @Input() public batchEditingAllowDeleting: boolean = true;
  /**
   * DKM-2587: satır bazlı Sil. Verilirse Sil (çöp kutusu) butonu her satır için
   * bu fonksiyonla sorulur; false dönen satırda buton PASİF (gri) çizilir, aynı
   * gridde diğer satırlarda aktif kalır (DevExtreme columns.buttons.disabled
   * fonksiyon desteği). Verilmezse (varsayılan) Sil butonu bugünkü gibi yalnız
   * grid geneli koşula (DList ALLOW_DELETING_YN + form yetkisi + dönem) bağlıdır;
   * input'u geçmeyen ekranlarda hiçbir şey değişmez.
   * Grid geneli koşul kapalıysa (yetki yok vb.) satır fonksiyonu hiç çağrılmaz.
   * Yalnız görseldir: ekranın showDelete kontrolü ve servis Bs kuralı yerinde kalmalı.
   * Kural ekrandaki başka bir değere bağlıysa (ör. parametre sonradan yüklendi)
   * o değer değişince YENİ bir fonksiyon referansı verin; grid butonları yeniden çizer.
   */
  @Input() public satirSilinebilirMi?: (rowData: any) => boolean;
  /** DKM-2587: satirSilinebilirMi'den üretilen disabled fonksiyonu; referans sabit kalsın diye saklanır. */
  private satirSilPasifOnbellek?: { kaynak: (rowData: any) => boolean; fn: (e: any) => boolean };

  /**
   * DKM-2587: Sil butonlarının [disabled] değeri.
   * genelPasif = şablondaki bugünkü grid geneli ifade. satirSilinebilirMi yoksa
   * AYNEN döner (eski davranış); varsa ve genel koşul açıksa satır fonksiyonu döner.
   */
  silPasif(genelPasif: boolean): boolean | ((e: any) => boolean) {
    const kaynak = this.satirSilinebilirMi;
    if (genelPasif || typeof kaynak !== 'function') return genelPasif;
    if (this.satirSilPasifOnbellek?.kaynak !== kaynak) {
      this.satirSilPasifOnbellek = {
        kaynak,
        fn: (e: any) => {
          const veri = e?.row?.data;
          if (!veri) return false;
          try {
            return !kaynak(veri);
          } catch {
            // Kural hatası butonu kilitlemesin; servis yine engeller.
            return false;
          }
        },
      };
    }
    return this.satirSilPasifOnbellek.fn;
  }
  /**
   * dxo-editing allowUpdating/allowDeleting bunu kullanır.
   * batchEditing Input ilk true geldiğinde widget false→true geçişi görmezse
   * inline edit açılmaz; bu flag ile kapat-aç (false→true) simüle edilir.
   */
  batchEditingActive = false;
  /**
   * true olduğunda: batch modda bir hücrede Enter'a basılınca değişiklik kaydedilir
   * ve bir alt satırdaki aynı kolon hücresi otomatik olarak düzenlemeye açılır
   * (dikey hızlı veri girişi). Sadece bu davranışı isteyen gridlerde açılmalıdır;
   * varsayılan Enter davranışı (diğer gridler) değişmez.
   */
  @Input() public batchEnterEditNextRow: boolean = false;
  @Input() public rowColorCondition!: GridConditionModel[];
  @Input() public bothConditionAreField: boolean = false;
  @Input() public emphasizeRowIndex: number;
  @Input() public rowStyleCondition!: GridConditionModelForCss[];
  @Input() public columnStyleCondition!: GridConditionModelForColumnCss [];
  @Input() public headerStyleCondition!: GridHeaderConditionModelForCss[];
  @Input() public rowAlternationEnabled: boolean = true;
  /**
   * DevExtreme DataGrid editMode === 'form' iken satır altı edit formunu
   * custom Angular template ile render etmek için kullanılır.
   */
  @Input() public editFormTemplate?: TemplateRef<any> = undefined;
  @Input() public historyGetCode!: any;
  @Input() public setFilterValues: any[] = [];
  @Input() public filterValue: any;
  @Input() public clearSelection: boolean;
  @Input() public clearSelectionCounter: number;
  @Input() public clearAllFilter: boolean;
  @Input() public gridDisabled = false;
  @Input() public scrollToFocusedRowKey: number;
  @Input() public alwaysFocusedRowFirst = false;
  @Input() public setUniqField: string;
  @Input() gridLocked: boolean = false;
  // @Input() public showSelection = false;
  // @Input() public allowSelection = false;
  @Input() public height!: any;
  @Input() public bakiyeDisplay = false
  @Input() public maxHeight!: string;
  @Input() public heightAnimation!: string;
  @Input() public animationHeightStart!: string;
  @Input() public animationHeightEnd!: string;
  @Input() public style!: any;
  @Input() public width = '100%';
  @Input() public gridId!: string;
  @Input() public allMode = 'page';
  @Input() public scrollingMode: DataGridScrollMode = 'standard';
  @Input() public userProcessType = 'Tooltip';
  @Input() public noDataText = 'Veri yok.';
  @Input() public customNoDataText:string;
  @Input() public defaultSelectFirstItem = false;
  @Input() public sortByItem!: string;
  @Input() public showToolbar: boolean = true;
  @Input() public focusedRowIndex!: number;
  @Input() public focusedRowKey!: any;
  @Input() public navigateRowKey!: any;
  @Input() public focusedRowEnabled: boolean = true;   //XXXXXXXXXXXX
  @Input() public selectedRowKeys: any[];
  @Input() public sortDescending!: boolean;
  @Input() public birimBildirimCondition!: boolean;
  @Input() public gelenBildirimCondition!: boolean;
  @Input() public gorevAtamaCondition!: boolean;
  @Input() public gorevlerimCondition!: boolean;
  @Input() public personelGorevIzlemeCondition!: boolean;
  @Input() public sosyalYardimBasvuruCondition!: boolean;
  @Input() public iptalEdilenKayitlarCondition!: boolean;
  @Input() public nakitYardimRedCondition!: boolean;
  @Input() public onayGonderCondition!: boolean;
  @Input() public incelemeCondition!: boolean;
  @Input() public formItemsTriggerCondition!: boolean;
  //@Input() public onaylanmayanEvrakTasiCondition!: boolean;
  @Input() public iptalMalzemeCondition!: boolean;
  @Input() public isTotalFormulaDisable: boolean = false;
  @Input() bottomDynamicButtons: DynamicButton[];
  @Input() public imzaParafHavaleGoster!: boolean;
  @Input() public imzaParafEkBelge!: boolean;
  @Input() public imzaParafSonuclandir!: boolean;
  @Input() public imzaParafGorevOlustur!: boolean;
  @Input() public imzaParafIadeEt!: boolean;
  @Input() public evrakIzleKayit!: boolean;
  @Input() public evrakIzleIncele!: boolean;
  @Input() public evrakIzleBelgeEkleri!: boolean;
  @Input() public evrakIzleEvrakIade!: boolean;
  @Input() public evrakIzleEvrakDagitim!: boolean;
  @Input() public parametreSablonEdit!: boolean;
  @Input() public gasDosyaOduncAciklama: boolean;
  @Input() public gasDosyaOduncIadeEt: boolean;
  @Input() public gasDosyaOduncTeslimEt: boolean;
  @Input() public gasDosyaOduncTalepSil: boolean;
  @Input() public otherButtonsData: OtherButtons[];
  @Input() public cellTemplates: CellTemplate[];
  @Input() public editCellTemplates: CellTemplate[];
  @Input() public dontSelectDataSource: boolean = false;

  /**
   * 'Liste Ayarları' ve 'Liste Resetleme' butonlarını gizler.
   *
   * Bu iki buton SetDlist_Request ile gridCtlList.dlistCode'a YAZAR. GenDlist'te
   * kayıtlı olmayan sentetik bir dlistCode ile kullanılan gridlerde (ör. dinamik
   * rapor sonucu) çalışmazlar ve kayıt tablosunu kirletebilirler.
   *
   * Varsayılan false -> mevcut ekranların davranışı değişmez. Yalnızca DList'i
   * backend'de kayıtlı olmayan ekranlar true geçmeli.
   */
  @Input() public hideListSettingsButtons: boolean = false;

  /**
   * hideListSettingsButtons=false iken 'Liste Ayarları' butonu normalde
   * SetDlist_Request ile gridCtlList.dlistCode'a yazar. Bu callback verilmişse
   * onun yerine çağrılır - sentetik dlistCode'u olan ekranlar (ör. Dinamik Rapor
   * V2, DR_SetDList sorguId ile çalışıyor) kendi kayıt uçlarına yönlendirmek
   * için kullanır. Verilmişse 'Liste Resetleme' butonu da otomatik gizlenir:
   * reset kavramı sorguId tabanlı uçta yok, dlistCode'a yazan orijinal reset
   * akışının senteik dlistCode'a karşı çalışması istenmiyor.
   *
   * Varsayılan undefined -> mevcut ekranların davranışı değişmez.
   */
  @Input() public dlistSaveOverride?: (
    dxColumns: DxGridColumnDto[],
    resetYn: boolean
  ) => Promise<{ result: boolean; errorMessage?: string; dListMetadata: DlistDto }>;
  @Input() public isDragging: boolean = false;
  @Input() public errorRowEnabled: boolean = true;
  @Input() public pagerInfoText: string = '';
  // DKM-5052 Clara: true ise filtre/sıralama değişince işaretli (checkbox) satırlar silinmez (varsayılan false = eski davranış).
  // İleride GEN_DLISTS ayarına taşınabilir (öneri: KEEP_SELECTION_ON_FILTER_YN → gridCtlList.keepSelectionOnFilterYn).
  @Input() public keepSelectionOnFilter: boolean = false;
  @Input() public confirmDelete: boolean = true;
  @Input() public autoNavigateToFocusedRow: boolean = true;

  get gridAutoNavigateToFocusedRow(): boolean {
    return this.batchEditing ? false : this.autoNavigateToFocusedRow;
  }

  /** dxo-editing yetkileri: 'row' ile ekranın verdiği 'popup' aynı DList/form yetkilerini kullanır */
  get rowVeyaPopupEdit(): boolean {
    const mod = this.editingMode || this.gridCtlList?.editMode;
    return mod === 'row' || mod === 'popup';
  }
  @Input() public showHistoryButton: boolean = true;
  @Input() public manuelSelectionManage: boolean = true;
  @Input() public enablePivotGridMode: boolean = false;
  @Input() public pivotLoadUrl: string;
  @Input() public focusSearchBar: boolean = false;
  @Input() public tabSaveEnabled: boolean = true;
  @Input() public dynamicButtonsLocateInMenu: LocateInMenuMode = 'auto';
  @Input() public noDataSourceText:string = 'Detay için kayıt seçiniz.'
  @Input() public gridManuelRefreshButton:boolean = false;
  @Output() public clickEditButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickDeleteButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickHistoryButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickBatchSaveButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickMenuButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickOtherBtn: EventEmitter<any> = new EventEmitter();
  @Output() public clickTekinGorButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickBottomDynamicButtons: EventEmitter<any> = new EventEmitter();
  @Output() public clickTahsilatGorButton: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickOtherButtonFirst: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickOtherButtonSecond: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickOtherButtonThird: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickOtherButtonFourth: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickOtherButtonFifth: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickBothDeleteEditButton: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickPreviewButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickAddButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickAddCustomButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickTeklifVerButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickMuayeneEkleButton: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickMuayeneDetayGorButton: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickMahsupGorButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickIadeGorButton: EventEmitter<any> = new EventEmitter();
  @Output() public clickColumnWithButtonButton: EventEmitter<any> =
    new EventEmitter();
  @Output() public clickDetailButton: EventEmitter<any> = new EventEmitter();
  @Output() public selectedRowData: EventEmitter<any> = new EventEmitter();
  @Output() public validationErrorMessage: EventEmitter<any> =
    new EventEmitter();
  @Output() public rowDblClick: EventEmitter<any> = new EventEmitter();
  @Output() public focusedRowIndexNumber: EventEmitter<any> =
    new EventEmitter();
  @Output() public rightClicked: EventEmitter<any> = new EventEmitter();
  @Output() public focusedRowChanged: EventEmitter<any> = new EventEmitter();
  @Output() public onEditorPreparingEvent: EventEmitter<any> =
    new EventEmitter();
  @Output() dynamicTableHeaderButtonClicked = new EventEmitter<void>();
  @Output() switchButtonResult = new EventEmitter<boolean>();
  @Output() customHeaderSwitchButtonValueResult = new EventEmitter<boolean>();
  @Output() public keyDown: EventEmitter<any> = new EventEmitter();
  @Output() private gridFilterChanged: EventEmitter<OptionChangedEvent> = new EventEmitter<any>();
  @Output() private onRowUpdating: EventEmitter<any> = new EventEmitter<any>();
  @Output() private onInitNewRowEmit: EventEmitter<any> = new EventEmitter<any>();
  @Output() private onRowRemoving: EventEmitter<RowRemovingEvent> = new EventEmitter<RowRemovingEvent>();
  @Output() private onRowInserting: EventEmitter<any> = new EventEmitter<any>();
  @Output() private actionSheetMenuButtonClick = new EventEmitter<any>();
  @Output() private rowPrepared = new EventEmitter<any>();
  @Output() private onContentReady = new EventEmitter<ContentReadyEvent>();
  @Output() private selectedRowKeysChange = new EventEmitter<any>();
  @Output() private focusedCellChanged = new EventEmitter<any>();
  @Output() private focusedCellChanging = new EventEmitter<any>();
  @Output() private dropDownSelectChanged = new EventEmitter<any>();
  @Output() private chevronButtonClicEvent = new EventEmitter<any>();
  @Output() private customSearch = new EventEmitter<any>();
  @Output() private dataGridGridRefreshOnClick = new EventEmitter<any>();
  @Input() public unsavedChangesGuard?:()=>Promise<boolean>;
  private isGuardProcessing=false;
  pivotGridMode: boolean = false;
  historyPopupVisible = false;
  historyFilterData!: HistoryFilterData;
  public isAdmin = false;
  userListEditRole: string = '';
  public isListEditAdmin = false;
  public searchListenerAttached = false;

  sumResults: any[] = [];

  selectedRowsTotal = 0;
  lookupData: any;
  valueFormat: Format;
  gridListCtlNew: DlistDto;
  userProcessData: UserProcessData = new UserProcessData();
  public allowedPageSizes = [10, 20, 50, 100];
  public currencyFormat = CURRENCY_FORMAT;

  readonly displayModes = [
    {text: "Display Mode 'full'", value: 'full'},
    {text: "Display Mode 'compact'", value: 'compact'},
  ];
  actionSheetTarget: any = '';

  displayMode: PagerDisplayMode = 'adaptive';
  showAttributes = false;
  showPageSizeSelector = true;
  showInfo = true;
  showSumInfo: boolean;
  showNavButtons = true;
  columnChooserModes: any;
  searchEnabled: boolean;
  editorOptions: any;
  allowSelectAll: any;
  selectByClick: any;
  recursive: any;
  showFilterRow: boolean;
  showPaging: boolean;

  showColumnChooser: boolean;
  showGroup: boolean;
  checkBoxesMode: string;
  target: any;
  addRow: boolean = false;
  //selectedRows: number[] = [];
  selectionChangedBySelectbox: boolean;

  actionSheetVisible = false;
  private actionSheetRowData: any;
  gridSettingsPageVisible: boolean = false;
  selectedListRowWithName: GenDlist = new GenDlist();
  private gridSettingState: any;
  private gridContainer:Element | any;
  private gridClickHandler = (event: any) => { this.setFilterOption() };


  customizeColumns(columns: any) {
    columns[0].width = 70;
  }

  public columnType = ColumnTypes;
  gridIdRandom: any;
  showTarget: any;

  clearFilterButtonOptions = {
    icon: 'clear',
    hint: 'Temizle',
    onClick: () => {
      this.clearHeaderFilter();
    },
  };
  refreshDataGridButtonOptions = {
    icon: 'refresh',
    hint: 'Yenile',
    onClick: () => {
      this.refreshDataGrid();
    },
  };
  showSettingPopupOptions = {
    icon: 'preferences',
    hint: 'Tercihler',
    onClick: (e: any) => {
      this.eventHandlerTercihler(e);
    },
  };

  batchSaveButtonOptions = {
    icon: 'save',
    text: 'Kaydet',
    hint: 'Kaydet',
    stylingMode: 'contained',
    type: 'success',
    onClick: () => {
      this.batchSaveFunc();
    },
  };

  batchAddButtonOptions = {
    icon: 'add',
    hint: 'Ekle',
    onClick: () => {
      this.batchAddFunc();
    },
  };
  tableHeaderAddButtonOpt = {
    icon: 'plus',
    hint: 'Ekle',
    stylingMode: 'contained',
    type: 'default',
    text: 'Ekle',
    onClick: () => {
      this.handleTableHeaderNewBtn()
    }
  }
  gridStateSettingButton = {
    icon: 'rowproperties',
    hint: 'Liste Ayarları',
    stylingMode: 'contained',
    type: 'default',
    elementAttr: {},
    onClick: () => {
      this.handleGridSettingSaveBtn()
    }
  }
  gridStateSettingResetButton = {
    icon: 'clearsquare',
    hint: 'Liste Resetleme',
    stylingMode: 'contained',
    type: 'danger',
    elementAttr: {},
    onClick: () => {
      this.handleResetGridSettingSaveBtn()
    }
  }

  editCaptionPopupVisible = false;
  captionEditText = '';
  editingColumnField: string | null = null;


  private focusedCell = {rowIndex: -1, columnIndex: -1, dataField: null as string | null, data: null as any}
  private focusedRow: any;

  /**
   * editMode === 'form' iken, custom template'e geçirilecek "aktif satır" datası.
   * DevExtreme'in form template context'i bazı durumlarda eksik/partial gelebiliyor.
   */
  public formEditRowData: any = null;

  constructor(
    private formMetadataService: FormMetadataService,
    public ortakService: OrtakService,
    private dListService: DListService,
    public screenService: ScreenService,
    private authService: AuthService,
    private dataCoreService: DataCoreService,
    private http: HttpClient,
    private utilsService: UtilsService,
    private genPivotGridService: GenPivotGridService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    this.otherActionClicked.bind(this);

    this.clickShowHistoryButtonFunc =
      this.clickShowHistoryButtonFunc.bind(this);
    // this.calculateCustomSummary1.bind(this)
    this.gridIdRandom = 'grid_' + Math.random().toString(36).substring(7);
    locale('tr');
    config({defaultCurrency: 'TRY', forceIsoDateParsing: true});
    this.checkBoxesMode = themes.current().startsWith('material')
      ? 'always'
      : 'always';
    this.showFilterRow = true;
    this.showSumInfo = false;
    this.showGroup = true;
    this.showColumnChooser = true;
    this.showPaging = true;
    this.searchEnabled = true;
    this.editorOptions = {placeholder: 'Ara'};
    this.allowSelectAll = true;
    this.selectByClick = true;
    this.recursive = true;
    this.columnChooserModes = [
      {
        key: 'dragAndDrop',
        name: 'Sürükle ve bırak',
      },
      {
        key: 'select',
        name: 'Seç',
      },
    ];
    const storageValue = localStorage.getItem('storage');
    if (storageValue) {
      const storageData = JSON.parse(storageValue);
      if (storageData && storageData.pageSize === 0) {
        storageData.pageSize = 10;
        localStorage.setItem('storage', JSON.stringify(storageData));
      }
    }

  }

  ngOnInit() {
    this.tableHeaderAddButtonOpt.text = this.tableAddNewButton?.newButtonText
    this.tableHeaderAddButtonOpt.icon = this.tableAddNewButton?.icon || 'plus'

    this.isAdmin = this.authService.isUserAdmin();
    this.gridSettingTypeButton();

    if (this.inlineMenuActions && this.gridCtlList.historyEntity && this.showHistoryButton &&
      !this.inlineMenuActions.some(action => action.value === 'history')) {
      this.inlineMenuActions.push({
        value: 'history',
        name: 'History',
        icon: 'clock',
        disable: false,
        disabled: false,
      });
    }
  }

  gridSettingTypeButton(){
    const roleStatus = this.authService.isListRole();
    const isDaBAdmin = roleStatus.isDaBAdmin;
    const isListAdmin = roleStatus.isListAdmin;
    const isElseRole = roleStatus.isElse;

    if (isDaBAdmin) {
      this.userListEditRole = 'DaBAdmin';
      this.isListEditAdmin = true;
      this.gridStateSettingButton.type = 'normal';
      this.gridStateSettingResetButton.type = 'normal';
      // type özelliği zorunluysa 'default' bırakılabilir, asıl renk CSS ile belirlenir.
      this.gridStateSettingResetButton.elementAttr= {class:'custom-orange-type'};
      this.gridStateSettingButton.elementAttr= {class:'custom-orange-type'};
      this.gridStateSettingButton.hint = 'DaBAdmin Ayarları';
    }
    else if (isListAdmin) {
      this.userListEditRole = 'ListAdmin';
      this.gridStateSettingButton.type = 'danger';
      this.gridStateSettingResetButton.type = 'danger';
      this.gridStateSettingButton.hint = 'ListAdmin Ayarları';
    }
    else {
      this.userListEditRole = '';
      this.gridStateSettingButton.type = 'normal';
      this.gridStateSettingResetButton.type = 'normal';
      this.gridStateSettingButton.hint = 'Kullanıcı Ayarları';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formMetaData'] && this.isAdmin) {
      // formMetaData tanımlı değilse boş bir nesne oluştur
      if (!this.formMetaData) {
        this.formMetaData = {} as FormDto;
      }

      // formYetki tanımlı değilse admin için varsayılan yetkileri ata
      if (!this.formMetaData.formYetki) {
        this.formMetaData.formYetki = new FormYetkiDto();
      }

      // Admin yetkilerini ayarla
      this.formMetaData.formYetki.deleteYn = true;
      this.formMetaData.formYetki.updateYn = true;
      this.formMetaData.formYetki.insertYn = true;
      this.formMetaData.formYetki.executeYn = true;
      this.formMetaData.formYetki.exportYn = true;
    }

    if (changes && changes['animationHeightEnd']) {
      document.documentElement.style.setProperty(
        '--start-height',
        this.animationHeightStart
      );
      document.documentElement.style.setProperty(
        '--end-height',
        this.animationHeightEnd
      );
    }

    if (changes && changes['focusedRowIndex']) {
      this.focusedRowIndex = changes['focusedRowIndex'].currentValue;
    }

    if (changes && changes['userProcessType']) {
      this.userProcessData.tooltip = this.userProcessType;
    }
    if (changes['editingMode']) {
      this.editingMode = changes['editingMode'].currentValue;
      // this.gridCtlList.editMode = this.editingMode;
      this.addRow = true
    }

    if (changes && changes['batchEditing']) {
      const enabled = !!changes['batchEditing'].currentValue;
      this.batchEditing = enabled;
      // İlk true DX'e işlem yaptırmıyor; kapat-aç (true→false→true) yaptırıyor.
      // allowUpdating'i süren batchEditingActive ile aynı geçişe sokuyoruz.
      if (enabled) {
        this.batchEditingActive = true;
        this.cdr.detectChanges();
        setTimeout(() => {
          this.batchEditingActive = false;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.batchEditingActive = true;
            this.cdr.detectChanges();
          });
        });
      } else {
        this.batchEditingActive = false;
      }
    }
    // array kontrolünün sebebi dataSource.load() metodu ile gelen verilerin array olması
    // eğer load() ile veriler dizi olarak gelirse select metodu çalışmıyor
    if (changes && changes['dataSource'] && this.dataSource && !Array.isArray(this.dataSource) && !this.dontSelectDataSource) {
      // customStore extend kullanımı için
      if (this.gridCtlList?.fields) {
        var extendColumn: string[] = [];
        this.gridCtlList.fields.forEach(item => {
          if (item?.dataField) {
            extendColumn.push(item.dataField);
          }
        })
        this.dataSource.select(extendColumn);
      }
      this.focusedRowEnabled = true


    }


    if (changes && changes['navigateRowKey']) {
      if (this.navigateRowKey) {
        setTimeout(() => {
          this.dataGrid?.instance.navigateToRow(this.navigateRowKey)
        }, 2000)
      }
    }

    if (changes && changes['clearSelection']) {
      if (this.clearSelection) {
        setTimeout(() => {
          this.dataGrid?.instance.clearSelection();
          this.clearSelection = false
        }, 1000)
      }
    }
    if (changes && changes['clearSelectionCounter']) {
        setTimeout(() => {
          this.dataGrid?.instance.clearSelection();
        }, 1000)
    }
    if (changes && changes['clearAllFilter']) {
      if (this.clearAllFilter) {
        setTimeout(() => {
          this.clearHeaderFilter();
          this.clearAllFilter = false
        }, 100)
      }
    }

    if (changes && changes['scrollToFocusedRowKey']) {
      if (this.scrollToFocusedRowKey) {
        setTimeout(() => {
          this.dataGrid.instance.navigateToRow(this.focusedRowKey);
        }, 100);
      }

    }
    if (changes && (changes['gridCtlList'] || changes['dataSource'])) {
      this.ilkSatirlarUygula();
    }
    if (changes && changes['gridCtlList']) {
      this.aramaDisiKolonlar = this.aramaDisiKolonlariOku(this.gridCtlList);
      setTimeout(() => {
        //multiple selectBox show options
        if (!this.gridCtlList.showSelectionYn && this.dataGrid) {
          this.dataGrid.instance.option("selection.showCheckBoxesMode", this.gridCtlList.showSelectionYn)
        }
      }, 100);

    }

    if (changes && changes['setFilterValues']) {
      setTimeout(() => {
        this.applyFilters('onchanges')
      }, 1000)
    }


    // if (changes && changes['rowColorFor']) {
    //   this.renderer.setStyle(this.el.nativeElement, '--custom-color', this.rowColorFor.color);
    // }
  }

  /**
   * VWD-PERF 2026-10-06: Genel aramanın (arama kutusu) dışında tutulacak kolonlar — GEN_DLISTS.PARAMS içinde
   * {"aramaDisi":["KisiAdres", ...]}. Bu kolonlar yine kolon süzgecinden aranabilir (allowFiltering değişmez);
   * yalnız arama kutusunun OR zincirine girmez. Hesaplanan pahalı kolonlarda (ör. vGenKisi.KisiAdres) her
   * aramada tüm satırlar için o kolonun hesaplanmasını önler. PARAMS boşsa hiçbir kolon etkilenmez.
   */
  aramaDisiKolonlar: Set<string> = new Set();

  /** GEN_DLISTS.PARAMS JSON'u; boş/bozuksa {} (bozuksa konsola uyarı). */
  private dlistParamsOku(dlist: DlistDto | null | undefined): any {
    if (!dlist?.params?.trim()) return {};
    try {
      return JSON.parse(dlist.params) ?? {};
    } catch {
      console.warn(`[${dlist.dlistCode}] PARAMS JSON okunamadı, yok sayıldı`);
      return {};
    }
  }

  /**
   * VWD-PERF 2026-10-07: PARAMS {"ilkSatirlar":true} → bu gridin store'unun yükleme isteklerine ilkSatirlar=1 eklenir,
   * DataServices sayfa sorgusuna Oracle FIRST_ROWS ipucu koyar. Yalnız DataCoreService.getOData ile kurulmuş
   * store'larda (__dkAyar) etkili; diğer veri kaynaklarında hiçbir şey yapmaz. Her grid 3 belediyede ölçülüp açılır.
   */
  private ilkSatirlarUygula(): void {
    const ds: any = this.dataSource;
    if (!ds || Array.isArray(ds)) return;
    const store = typeof ds.store === 'function' ? ds.store() : ds;
    if (store?.__dkAyar) {
      store.__dkAyar.ilkSatirlar = this.dlistParamsOku(this.gridCtlList)?.ilkSatirlar === true;
    }
  }

  private aramaDisiKolonlariOku(dlist: DlistDto | null | undefined): Set<string> {
    const sonuc = new Set<string>();
    if (!dlist?.params?.trim()) return sonuc;
    try {
      const liste = JSON.parse(dlist.params)?.aramaDisi;
      if (!Array.isArray(liste)) return sonuc;
      const alanlar = new Set((dlist.fields || []).map(f => f.dataField?.toLowerCase()));
      liste.forEach((k: any) => {
        const ad = String(k ?? '').trim().toLowerCase();
        if (!ad) return;
        if (!alanlar.has(ad)) console.warn(`[${dlist.dlistCode}] PARAMS.aramaDisi: '${k}' bu listede kolon değil`);
        sonuc.add(ad);
      });
    } catch {
      console.warn(`[${dlist.dlistCode}] PARAMS JSON okunamadı, aramaDisi uygulanmadı`);
    }
    return sonuc;
  }

  aramaDisi(dataField: string | undefined): boolean {
    return !!dataField && this.aramaDisiKolonlar.has(dataField.toLowerCase());
  }

  applyFilters(nerden: string) {
    if ((this.setFilterValues?.length > 0) && this.dataGrid?.instance) {
      this.setFilterValues.forEach(filter => {
        // Sonra filtreyi uygula
        this.dataGrid.instance.columnOption(filter.datafield, {
          filterValue: filter.filterValue,
          selectedFilterOperation: filter.selectedFilterOptions || '='
        });
      });
      // console.log(this.dataGrid?.instance)
      // this.setFilterValues.forEach(filter => {
      //   this.dataGrid?.instance?.columnOption(filter.datafield, {
      //     filterValue: filter.filterValue,
      //     selectedFilterOperation: filter.selectedFilterOptions // veya backend'den gelen operasyon
      //   });
      // });
    }
    // else {
    //   // null veya undefined ise tüm filtreleri kaldır
    //   this.columnList.forEach(column => {
    //     this.dataGrid?.instance?.columnOption(column.dataField, {
    //       filterValue: null
    //     });
    //   });
    // }
  }

  ngOnDestroy() {
    this.genPivotGridService.deletePivotFieldsMapByKey(this.gridCtlList?.dlistCode);
    const searchInput: HTMLInputElement | null = document.querySelector('.dx-datagrid-search-panel input');
    if (searchInput) {
      searchInput.removeEventListener('keydown', this.searchKeyHandler);
    }
    this.gridContainer?.removeEventListener('click', this.gridClickHandler);
  }

  // onReorder = (e: DxDataGridTypes.RowDraggingReorderEvent) => {
  //   const visibleRows = e.component.getVisibleRows();
  //   const toIndex = this.dataSource._items.findIndex((item: any) => item[this.keyExpr] === visibleRows[e.toIndex].data[this.keyExpr]);
  //   const fromIndex = this.dataSource._items.findIndex((item: any) => item[this.keyExpr] === e.itemData[this.keyExpr]);

  //   this.dataSource._items.splice(fromIndex, 1);
  //   this.dataSource._items.splice(toIndex, 0, e.itemData);
  //   this.dataSource.store().push([
  //     { type: 'remove', key: e.itemData[this.keyExpr] }, // Eski yerden sil
  //     { type: 'insert', data: e.itemData, index: toIndex } // Yeni yere ekle
  // ]);
  // };

  onReorder = (e: Parameters<DxDataGridTypes.RowDragging['onReorder']>[0]) => {
    e.promise = this.processReorder(e);
  };

  async processReorder(e: Parameters<DxDataGridTypes.RowDragging['onReorder']>[0]) {
    const visibleRows = e.component.getVisibleRows();
    // Drag yapılan satırın eski ve yeni konumlarını belirleme
    const fromIndex = this.dataSource._items.findIndex((item: any) => item[this.dragingKeyExpr] === e.itemData[this.dragingKeyExpr]);
    const toIndex = this.dataSource._items.findIndex((item: any) => item[this.dragingKeyExpr] === visibleRows[e.toIndex].data[this.dragingKeyExpr]);

    const updatedItem = {
      Kod: Number(e.itemData.Kod), // Tüm mevcut alanları koru
      [this.dragingKeyExpr]: Number(this.dataSource._items[toIndex][this.dragingKeyExpr]), // Yeni sıralama bilgisi
    };
    // Sıralama bilgilerini güncellemek için değişiklikleri ön yüz tarafında düzenleme
    this.dataSource._items.splice(fromIndex, 1);
    this.dataSource._items.splice(toIndex, 0, e.itemData);

    // Loading göstergesi başlat
    e.component.beginCustomLoading("Sıralama güncelleniyor...");

    try {
      // Sunucuya yeni sıralama verisini gönder
      await this.dataCoreService.updateDataStore(this.dragingTableName, updatedItem);

      // DataGrid’i yeniden yükle
      await this.dataSource.reload();
      await e.component.refresh();
    } catch (error) {
      console.error('Sıralama güncellenirken hata oluştu:', error);
    } finally {
      // Loading göstergesini kapat
      e.component.endCustomLoading();
    }

  }


  getLookupData(e: any) {
    const lookupData = this.ortakService.lookUpData?.find(
      ({lookupAd}) => lookupAd === e
    );
    return lookupData?.data || null;
  }

  ngAfterViewInit(): void {

    // this.ortakService.lookUpData$.subscribe(res => {
    //   this.lookupData = res;
    // })
    // DKM-5345 Cedric: eski hâli — addRow görünüm denetlendikten sonra aynı turda değişiyordu
    // (toolbar addRowButton [visible] false→true / true→false) → geliştirme modunda NG0100.
    // if (this.gridCtlList.editMode === 'popup') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'row') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'cell') {
    //   this.addRow = true;
    // } else if (this.gridCtlList.editMode === 'form') {
    //   this.addRow = true;
    // } else {
    //   this.addRow = false;
    // }
    // Değer aynı anda ve aynı kuralla hesaplanır; yalnız atama mikro göreve ertelenir
    // (canlıda da buton bir sonraki change detection turunda görünüyordu — davranış aynı).
    const mod = this.gridCtlList.editMode;
    const addRowAcik = mod === 'popup' || mod === 'row' || mod === 'cell' || mod === 'form';
    Promise.resolve().then(() => {
      this.addRow = addRowAcik;
    });

//
//     setTimeout(()=>{
//       this.applyFilters('afterviewdan')
//     })


  }

  // donemKontrol(){
  //   if(this.donemKontrolObject){
  //     this.columnList.map(x=>{
  //       if(x.dataField===this.donemKontrolObject.kontrolDataField){
  //         if(x.dataField<this.donemKontrolObject.donemKontrolDate){
  //           return true
  //         }else{return false}
  //       }
  //     })
  //   }
  // }

  getSelectedRow(e: any) {
    this.userProcessData = new UserProcessData({
      ...e.data,
      tooltip: this.userProcessType,
    });
    this.selectedRowData.emit(e);

    // this.defaultSelectFirstItem=false
    // if (!this.defaultSelectFirstItem) e.component.selectRowsByIndexes(null)
  }

  async getOnRowDblClick(e: any) {
    this.userProcessData = new UserProcessData({
      ...e.data,
      tooltip: this.userProcessType,
    });
    this.rowDblClick.emit(e);

    // Detay/kayıt açma logu, satır-altı edit (editWithDblClick) kapalı olup
    // dbl-click doğrudan dışarıda (örn. yeni tab açan showEdit) yönetildiğinde de
    // atılmalı - bu yüzden editWithDblClick koşulunun dışında tutuluyor.
    // formMetaData bu grid'e disaridan bind edilmemisse (bazi kullanimlarda edilmiyor)
    // formCode undefined kalir ve asagidaki string 'undefined/dlistCode' seklinde bozuk
    // bir formAd olarak loglanip GetLastXAction_Request'te hicbir zaman eslesmiyordu.
    if (e?.data && this.formMetaData?.formCode) {
      const formLogrequest = new FormAction_Request({
        formAd: this.formMetaData.formCode + '/' + this.gridCtlList?.dlistCode,
        kod: e.data?.Kod ? e.data?.Kod : e.data?.Id
      })
      this.ortakService.getFormAction(formLogrequest).pipe(take(1)).subscribe()
    }

    if (this.editWithDblClick) {
      // editMode === 'form' ise satır-altı edit row'u aç ve tam row datasını template'e hazırla
      if (this.gridCtlList?.editMode === 'form') {
        if (this.dataGrid?.instance?.option('editing.editRowKey') === e.key) {
          return;
        }
        if(this.unsavedChangesGuard){
          if(this.isGuardProcessing)return;
          this.isGuardProcessing=true;
          try{
            if(!await(this.unsavedChangesGuard())){
              this.isGuardProcessing=false;
              return;
            }
          }
          finally{
            this.isGuardProcessing=false;
          }
        }
        if (e?.data) {
          this.formEditRowData = structuredClone(e.data);
        }
        if (typeof e?.rowIndex === 'number') {
          this.dataGrid?.instance?.editRow(e.rowIndex);
        }
      }

      this.clickEditButton.emit({row: e});
    }
  }

  onGridInit(e: any) {
    setTimeout(() => {
      const searchInput: HTMLInputElement | null = document.querySelector('.dx-datagrid-search-panel input');

      if (searchInput && !this.searchListenerAttached) {
        this.searchListenerAttached = true;

        searchInput.addEventListener('keydown', this.searchKeyHandler);
      }
    });

  }

  searchKeyHandler = (event: KeyboardEvent) => {
    if (event.key === 'Tab') {
      event.preventDefault();
      const grid = this.dataGrid?.instance;
      setTimeout(() => {
        grid?.focus();
        grid?.navigateToRow(grid.getKeyByRowIndex(0));
        const cell = grid?.getCellElement(0, 0);
        if (cell) {
          (cell as HTMLElement).focus();
        }
      });
    }
  };


  onKeyDown(e: any) {
    this.keyDown.emit(e);

    if (this.editingMode !== 'batch') return;

    const key = e.event?.key;
    // Tab: DevExtreme yerel navigasyonu kullan (allowEditing ile editlenemez kolonları atlar)
    if (key === 'Tab') return;

    if (key !== 'Enter') return;
    if (e.handled) return;

    const grid = this.dataGrid.instance;
    const visibleRows = grid.getVisibleRows();

    let rowIndex = grid.option('focusedRowIndex') ?? -1;
    let colIndex = grid.option('focusedColumnIndex') ?? -1;

    const editingRowIndex = visibleRows.findIndex((r: any) => r.isEditing);
    if (editingRowIndex >= 0) {
      rowIndex = editingRowIndex;
    }

    // Opt-in: değer girip Enter'a basınca kaydeder ve bir alt satırdaki aynı kolon
    // hücresini otomatik düzenlemeye açar (dikey hızlı giriş). Yalnızca
    // batchEnterEditNextRow=true olan gridler için; diğerlerinin davranışı değişmez.
    if (this.batchEnterEditNextRow) {
      // focusedColumnIndex bazen -1 dönebiliyor; son focuslanan hücrenin dataField'ini
      // yedek kullanıyoruz (editCell hem index hem dataField kabul eder).
      const targetColOptIn: number | string = colIndex >= 0 ? colIndex : (this.focusedCell?.dataField ?? -1);

      // Virtual/infinite scroll'da focusedRowIndex absolute olabilir; editCell ise
      // görünür (relative) indeks ister. Bu yüzden her zaman visibleRows üzerinden çözüyoruz.
      let relativeRowIndex = visibleRows.findIndex((r: any) => r.isEditing);
      if (relativeRowIndex < 0) {
        const focusedKey = grid.option('focusedRowKey');
        if (focusedKey != null) {
          relativeRowIndex = visibleRows.findIndex((r: any) => r.key === focusedKey);
        }
      }
      if (relativeRowIndex < 0) {
        relativeRowIndex = grid.getRowIndexByKey?.(grid.option('focusedRowKey')) ?? -1;
      }
      if (relativeRowIndex < 0 || targetColOptIn === -1) return;

      // Kaydetme/scroll sonrası görünür indeksler kayar; hedefi key (veya dataIndex)
      // olarak ÖNCE yakalıyoruz ki alakasız satıra zıplamasın.
      const direction = e.event.shiftKey ? -1 : 1;
      const nextTarget = this.findBatchEnterNextTarget(grid, visibleRows, relativeRowIndex, direction);

      e.handled = true;

      // Satır henüz editte değilse önce mevcut hücreyi düzenlemeye al.
      if (!visibleRows[relativeRowIndex]?.isEditing) {
        grid.editCell(relativeRowIndex, targetColOptIn as any);
        return;
      }

      e.event.preventDefault();
      const saved = grid.hasEditData() ? grid.saveEditData() : Promise.resolve();
      Promise.resolve(saved).then(() => {
        if (nextTarget?.key != null) {
          this.focusBatchEditCellByKey(nextTarget.key, targetColOptIn);
        } else if (typeof nextTarget?.dataIndex === 'number') {
          this.focusBatchEditCellByDataIndex(nextTarget.dataIndex, targetColOptIn);
        }
      });
      return;
    }

    // Varsayılan (mevcut) davranış — diğer gridler için değişmeden korunur.
    if (rowIndex < 0 || colIndex < 0) return;

    const targetRow = e.event.shiftKey
      ? rowIndex - 1 < 0 ? visibleRows.length - 1 : rowIndex - 1
      : rowIndex + 1 >= visibleRows.length ? 0 : rowIndex + 1;
    const targetCol = colIndex;

    const saveOrEdit = () => {
      setTimeout(() => {
        if (grid.hasEditData()) {
          grid.saveEditData().then(() => grid.editCell(targetRow, targetCol));
        } else {
          grid.editCell(targetRow, targetCol);
        }
        e.event.preventDefault();
      }, 10);
    };

    e.handled = true;

    if (!visibleRows[rowIndex]?.isEditing) {
      grid.editCell(rowIndex, colIndex);
    } else {
      saveOrEdit();
    }
  }

  /**
   * Enter ile bir sonraki/önceki data satırını bulur.
   * Önce mevcut visible buffer'dan key alır; buffer sınırındaysa dataIndex döner
   * (virtual/infinite scroll bir sonraki sayfayı yükleyebilsin).
   * Görünür satır indeksine sarıp 0'a zıplamaz — bu, viewport alt satırında
   * alakasız satıra geçmeye yol açıyordu.
   */
  private findBatchEnterNextTarget(
    grid: any,
    visibleRows: any[],
    relativeRowIndex: number,
    direction: number
  ): { key?: any; dataIndex?: number } | null {
    const current = visibleRows[relativeRowIndex];
    if (!current) return null;

    if (direction > 0) {
      for (let i = relativeRowIndex + 1; i < visibleRows.length; i++) {
        if (visibleRows[i]?.rowType === 'data') {
          return { key: visibleRows[i].key, dataIndex: visibleRows[i].dataIndex };
        }
      }
    } else {
      for (let i = relativeRowIndex - 1; i >= 0; i--) {
        if (visibleRows[i]?.rowType === 'data') {
          return { key: visibleRows[i].key, dataIndex: visibleRows[i].dataIndex };
        }
      }
    }

    const currentDataIndex = current.dataIndex;
    if (typeof currentDataIndex !== 'number') return null;

    const totalCount =
      (typeof grid.totalCount === 'function' ? grid.totalCount() : undefined) ??
      grid.getDataSource?.()?.totalCount?.() ??
      -1;

    let targetDataIndex = currentDataIndex + direction;
    if (totalCount > 0) {
      if (targetDataIndex >= totalCount) targetDataIndex = 0;
      if (targetDataIndex < 0) targetDataIndex = totalCount - 1;
    } else if (targetDataIndex < 0) {
      return null;
    }

    return { dataIndex: targetDataIndex };
  }

  /**
   * Batch modda kaydetme/yükleme sonrası hedef hücreyi satır key'i ile düzenlemeye
   * açar. Virtual scroll sonrası görünür indeksler kaydığı için indeks yerine key
   * kullanılır; navigateToRow ile satır viewport'a getirilir.
   */
  private focusBatchEditCellByKey(rowKey: any, column: number | string, attempt: number = 0): void {
    const grid = this.dataGrid?.instance;
    if (!grid || rowKey == null) return;

    const openCell = () => {
      const rowIndex = grid.getRowIndexByKey(rowKey);
      if (rowIndex < 0) {
        if (attempt < 20) {
          setTimeout(() => this.focusBatchEditCellByKey(rowKey, column, attempt + 1), 40);
        }
        return;
      }

      grid.editCell(rowIndex, column as any);

      setTimeout(() => {
        const freshIndex = grid.getRowIndexByKey(rowKey);
        if (freshIndex < 0) {
          if (attempt < 20) {
            this.focusBatchEditCellByKey(rowKey, column, attempt + 1);
          }
          return;
        }
        const cell = grid.getCellElement(freshIndex, column as any) as HTMLElement | undefined;
        const input = cell?.querySelector('.dx-texteditor-input') as HTMLInputElement | null;
        if (input) {
          input.focus();
          input.select?.();
        } else if (attempt < 20) {
          this.focusBatchEditCellByKey(rowKey, column, attempt + 1);
        }
      }, 40);
    };

    const navigated = grid.navigateToRow(rowKey);
    Promise.resolve(navigated).then(openCell).catch(openCell);
  }

  /**
   * Hedef satır henüz visible buffer'da değilse (viewport altı / infinite scroll),
   * absolute dataIndex ile satırı görünür hale getirip ardından edit açar.
   */
  private focusBatchEditCellByDataIndex(dataIndex: number, column: number | string, attempt: number = 0): void {
    const grid = this.dataGrid?.instance;
    if (!grid || typeof dataIndex !== 'number') return;

    const rows = grid.getVisibleRows() || [];
    const match = rows.find((r: any) => r.rowType === 'data' && r.dataIndex === dataIndex);
    if (match?.key != null) {
      this.focusBatchEditCellByKey(match.key, column, attempt);
      return;
    }

    if (attempt >= 20) return;

    // Virtual scroll: focusedRowIndex absolute data indeksidir; satırı yükleyip kaydırır.
    const prevAutoNav = grid.option('autoNavigateToFocusedRow');
    grid.option('autoNavigateToFocusedRow', true);
    grid.option('focusedRowIndex', dataIndex);

    setTimeout(() => {
      grid.option('autoNavigateToFocusedRow', prevAutoNav);
      const refreshed = grid.getVisibleRows() || [];
      const found = refreshed.find((r: any) => r.rowType === 'data' && r.dataIndex === dataIndex);
      if (found?.key != null) {
        this.focusBatchEditCellByKey(found.key, column, attempt + 1);
      } else {
        this.focusBatchEditCellByDataIndex(dataIndex, column, attempt + 1);
      }
    }, 50);
  }



  // onRowPrepared(e:any) {
  //   e.rowElement.style.height = "50px";
  // }

  refreshDataGrid() {
    if(this.gridManuelRefreshButton){
      this.dataGridGridRefreshOnClick.emit();

    }else{
      this.dataGrid.instance.refresh();
    }
  }

  batchSaveFunc() {
    this.dataGrid.instance.saveEditData();
  }

  batchAddFunc() {
    this.dataGrid.instance.addRow();
  }

  onSaved($event: any) {
    if (this.editingMode === 'batch') {
      this.addRow = false;
      //this.gridCtlList.editMode='custom'
      //this.editingMode= 'popup'
    }
  }


  onEditorPreparing(e: any) {
    if(this.editFormTemplate !== undefined) {
      if (e.parentType === 'dataRow' && e.row?.isEditing) {
        e.editorOptions.height = '100%';
      }
    }

    if (this.editingMode === 'batch') {
      this.onEditorPreparingEvent.emit(e);

      // Batch + virtual scroll: editör değeri varsayılan olarak sadece blur ('change')
      // anında buffer'a yazılıyor. Kullanıcı değer girip hiçbir yere tıklamadan scroll
      // yapınca satır sanallaştırılıp DOM'dan silindiği için değer kayboluyor.
      // Her tuş vuruşunda commit etmesi için valueChangeEvent'i genişletiyoruz.
      if (e.parentType === 'dataRow' && this.batchEditing && this.gridCtlList?.pageCount === 0) {
        e.editorOptions.valueChangeEvent = 'keyup change blur input';
      }
    }
    if (e.parentType === 'filterRow') {
      e.editorOptions.inputAttr = {class: 'from-filter-row'};
      e.editorOptions.onOpened = () => {
        setTimeout(() => {
          const overlays = document.querySelectorAll('.dx-overlay-content');
          overlays.forEach(el => el.classList.add('popup-from-filter-row'));
        }, 0);
      };
    }
    // if (e.editorElement && (this.editingMode === 'batch')) {
    //   const input = e.editorElement.querySelector('input');
    //   if (input) {
    //     input.addEventListener('keydown', (event: KeyboardEvent) => {
    //       if (event.key === 'Tab') {
    //         // Grid'in kendi keydown'ına ilet
    //         this.onKeyDown({ event, handled: false });
    //         event.preventDefault();
    //       }
    //     });
    //   }
    // }
  }

  searchValueChange(e: any) {
    this.customSearch.emit(e)
  }

  isFirstOtherButtonVisible = (e: any) => {
    if (
      (e.row.data.ListeTuru === 1 || e.row.data.ListeTuru === 3) &&
      this.gorevAtamaCondition
    )
      return true;
    if (this.gorevlerimCondition) return true;
    if (this.sosyalYardimBasvuruCondition) return true;
    if (e.row.data.GelenEvrakDurumu === null && this.onayGonderCondition)
      return true;
    if (
      this.birimBildirimCondition &&
      e.row.data.Status !== 4 &&
      e.row.data.Status !== 5
    )
      return true;
    if (
      this.gelenBildirimCondition &&
      e.row.data.IbbGelenGiden !== 'G' &&
      (e.row.data.Status === 1 || e.row.data.Status === 3)
    )
      return true;
    if (this.personelGorevIzlemeCondition) return true;
    if (this.iptalEdilenKayitlarCondition) return true;
    if (this.nakitYardimRedCondition) return true;
    if (this.incelemeCondition) return true;
    if (this.formItemsTriggerCondition) return true;
    //if(this.onaylanmayanEvrakTasiCondition) return true;
    if (this.iptalMalzemeCondition) return true;
    if (this.imzaParafHavaleGoster) return true; //&& e.row.data.GorevKod === 8888888888
    if (this.evrakIzleKayit) return true;
    if (this.parametreSablonEdit) return true;
    if (this.gasDosyaOduncAciklama) return true;

    return false;
  };

  isSecondOtherButtonVisible = (e: any) => {
    if (
      (e.row.data.ListeTuru === 3 || e.row.data.ListeTuru === 1) &&
      this.gorevAtamaCondition
    )
      return true;
    if (
      e.row.data.Status !== 2 &&
      this.birimBildirimCondition &&
      e.row.data.Status !== 4 &&
      e.row.data.Status !== 5
    )
      return true;
    if (this.gorevlerimCondition) return true;
    if (this.sosyalYardimBasvuruCondition) return true;
    if (this.onayGonderCondition) return true;
    if (this.gelenBildirimCondition && e.row.data.Status !== 5) return true;
    if (this.incelemeCondition) return true;
    if (this.imzaParafEkBelge) return true; //&& e.row.data.GorevKod === 8888888888 //EkbelgeKod > 0 viewdan geldiginde ekle!!
    if (this.evrakIzleIncele) return true;
    if (
      this.gasDosyaOduncIadeEt &&
      e.row.data.TalepStatu !== 1 &&
      e.row.data.TalepStatu !== 2
    )
      return true;

    return false;
  };

  isThirdOtherButtonVisible = (e: any) => {
    if (e.row.data.ListeTuru === 2 && this.gorevAtamaCondition) return true;
    if (
      e.row.data.Status === 2 &&
      this.birimBildirimCondition &&
      e.row.data.Status !== 4 &&
      e.row.data.Status !== 5
    )
      return true;
    if (this.gorevlerimCondition) return true;
    if (this.sosyalYardimBasvuruCondition) return true;
    if (this.incelemeCondition) return true;
    if (this.imzaParafSonuclandir) return true; // && (e.row.data.Status === 1 || e.row.data.Status === 4 ||e.row.data.Status === 5)  view dan Status dondugunde ekle!
    if (this.evrakIzleBelgeEkleri) return true;
    if (
      this.gasDosyaOduncTeslimEt &&
      e.row.data.TalepStatu !== 2 &&
      e.row.data.TalepStatu !== 9
    )
      return true;
    return false;
  };

  isFourthOtherButtonVisible = (e: any) => {
    if (
      e.row.data.Status === 1 &&
      this.birimBildirimCondition &&
      e.row.data.Status !== 4 &&
      e.row.data.Status !== 5
    )
      return true;
    if (this.sosyalYardimBasvuruCondition) return true;
    if (this.incelemeCondition) return true;
    if (this.imzaParafGorevOlustur) return true; //&& e.row.data.GorevKod === 8888888888// && (e.row.data.Status === 1 || e.row.data.Status === 4 ||e.row.data.Status === 5)  view dan Status dondugunde ekle!
    if (this.evrakIzleEvrakIade) return true;
    if (
      this.gasDosyaOduncTalepSil &&
      e.row.data.TalepStatu !== 2 &&
      e.row.data.TalepStatu !== 9
    )
      return true;
    else return false;
  };

  isFifthOtherButtonVisible = (e: any) => {
    if (this.imzaParafIadeEt && e.row.data.PersonelKod !== null) return true; // && e.row.data.GorevKod === 8888888888// && (e.row.data.Status === 1 || e.row.data.Status === 4 ||e.row.data.Status === 5)  view dan Status dondugunde ekle!
    if (this.evrakIzleEvrakDagitim && e.row.data.GittigiYerTur === 'I')
      return true;
    return false;
  };

  public clickEditButtonFunc = async(e: any) => {
    // editMode === 'form' ise grid'in edit row'unu (form row) aç
    if (this.gridCtlList?.editMode === 'form') {
        if(this.unsavedChangesGuard){
          if(this.isGuardProcessing)return;
          this.isGuardProcessing=true;
          try{
            if(!await(this.unsavedChangesGuard())){
              this.isGuardProcessing=false;
              return;
            }
          }
          finally{
            this.isGuardProcessing=false;
          }
        }
        if (e?.row?.data) {
          this.formEditRowData = structuredClone(e.row.data);
        }
        const rowIndex = e?.row?.rowIndex;
        if (typeof rowIndex === 'number') {
          this.dataGrid?.instance?.editRow(rowIndex);
        }
    }
    if (e?.row?.data && this.formMetaData?.formCode) {
      const formLogrequest = new FormAction_Request({
        formAd: this.formMetaData.formCode + '/' + this.gridCtlList?.dlistCode,
        kod: e.row.data?.Kod ? e.row.data?.Kod : e.row.data?.Id
      })
      this.ortakService.getFormAction(formLogrequest).pipe(take(1)).subscribe()
    }
    this.clickEditButton.emit(e);
  };


  public clickDeleteButtonFunc = (e: any) => {
    this.clickDeleteButton.emit(e);
  };

  clickShowHistoryButtonFunc(e: any) {
    this.clickHistoryButton.emit(e);
    this.setHistoryFilterData(e.row.data);
    this.historyPopupVisible = true;
  }

  public clickmenuButtonFunc = (e: any) => {
    this.actionSheetMenuButtonClick.emit(e);
    this.actionSheetTarget = e.event.currentTarget;
    this.actionSheetVisible = true;
    this.actionSheetRowData = e.row.data;
  };

  public clickOtherButtonFuncFirst = (e: any) => {
    this.clickOtherButtonFirst.emit(e);
  };
  public clickOtherButtonFuncSecond = (e: any) => {
    this.clickOtherButtonSecond.emit(e);
  };
  public clickOtherButtonFuncThird = (e: any) => {
    this.clickOtherButtonThird.emit(e);
  };
  public clickOtherButtonFuncFourth = (e: any) => {
    this.clickOtherButtonFourth.emit(e);
  };
  public clickOtherButtonFuncFifth = (e: any) => {
    this.clickOtherButtonFifth.emit(e);
  };

  public clickBothDeleteEditButtonFunc = (e: any) => {
    this.clickBothDeleteEditButton.emit(e);
  };

  public clickDetailButtonFunc = (e: any) => {
    this.clickDetailButton.emit(e);
  };

  public clickAddButtonFunc = (e: any) => {
    this.clickAddButton.emit(e);
  };

  public clickTeklifVerButtonFunc = (e: any) => {
    this.clickTeklifVerButton.emit(e);
  };

  public clickMuayeneEkleButtonFunc = (e: any) => {
    this.clickMuayeneEkleButton.emit(e);
  };
  public clickMuayeneDetayGorButtonFunc = (e: any) => {
    this.clickMuayeneDetayGorButton.emit(e);
  };

  public onFocusedRowChangedFunc = (e: any) => {
    this.focusedRowChanged.emit(e)


  };


  public onFocusedCellChangingFunc = (e: any) => {
    this.focusedCellChanging.emit(e);
  };


  calculateCustomSummary(options: any) {
    const item = this.sumListItems.find((el) => el.name === options.name);
    if (item) {
      let totalValue = 0;
      this.dataSource.forEach((row: any) => {
        totalValue += row[item.column];
      });

      if (item.valueFormat === 'currency') {
        options.totalValue = totalValue.toLocaleString('tr-TR', {
          style: 'currency',
          currency: 'TRY',
        });
      } else {
        options.totalValue = totalValue;
      }
    }
  }

  clearFilter() {
    //this.dataGrid.instance.clearFilter();
  }

  // showToolbars(){
  //   if(this.showToolbar){
  //     this.showToolbar = false;
  //   }
  //   else{
  //     this.showToolbar = true;
  //   }
  //
  // }
  // Liste yönetiminde sayfa satır sayısı (pageCount) 0 ise grid virtual scrolling ile çalıştığından
  // dataSource.items() sadece yüklenmiş ilk sayfayı (50 satır) döner. Bu durumda mevcut filtre/sıralama ile
  // store'dan tüm kayıtlar çekilir; pageCount > 0 ise gridde yüklü olan sayfa (pageCount kadar satır) aktarılır.
  private async getExportItems(dataGrid: any): Promise<any[]> {
    const dataSource = dataGrid.getDataSource();
    if (this.gridCtlList?.pageCount !== 0) {
      return dataSource.items();
    }
    const sort = dataGrid.getVisibleColumns()
      .filter((col: any) => col.sortOrder && (col.dataField || typeof col.calculateSortValue === 'string'))
      .sort((a: any, b: any) => a.sortIndex - b.sortIndex)
      .map((col: any) => ({
        selector: typeof col.calculateSortValue === 'string' ? col.calculateSortValue : col.dataField,
        desc: col.sortOrder === 'desc'
      }));
    const loadOptions: any = {
      ...(dataSource.loadOptions() ?? {}),
      filter: dataGrid.getCombinedFilter(true) ?? null,
      sort: sort.length ? sort : (dataSource.sort() ?? null),
      requireTotalCount: false
    };
    delete loadOptions.skip;
    delete loadOptions.take;
    delete loadOptions.group;
    try {
      const result: any = await dataSource.store().load(loadOptions);
      return Array.isArray(result) ? result : (result?.data ?? []);
    } catch (err) {
      console.warn('PDF export: tüm kayıtlar yüklenemedi, yüklü satırlar aktarılıyor', err);
      return dataSource.items();
    }
  }

  private getExportColumns(dataGrid: any): any[] {
    return dataGrid.getVisibleColumns()
      .filter((col: any) => col.dataField !== 'İşlemler' && col.type !== 'selection');
  }

  /**
   * DKM-5296: PDF ve virtual scroll Excel aktarımı satırları elle yazdığı için gridin alt toplamları
   * (dxo-summary totalItems) dosyaya hiç yazılmıyordu (normal Excel yolu exportDataGrid ile zaten yazar).
   * Toplamlar aktarılan satırlardan hesaplanır; dönen her dizi bir toplam satırıdır, hücreler kolon sırasındadır.
   */
  private getExportTotalRows(dataGrid: any, columns: any[], items: any[]): (ExportToplamHucre | null)[][] {
    let totalItems: any[] = [];
    try {
      totalItems = typeof dataGrid?.option === 'function' ? (dataGrid.option('summary.totalItems') ?? []) : [];
    } catch {
      totalItems = [];
    }
    if (!Array.isArray(totalItems) || !totalItems.length) {
      return [];
    }
    const rows = this.flattenExportItems(items);
    const perColumn = columns.map((col: any) =>
      totalItems.filter((t: any) => t && (t.showInColumn ?? t.column) === col.dataField));
    const rowCount = Math.max(0, ...perColumn.map((list) => list.length));
    const result: (ExportToplamHucre | null)[][] = [];
    for (let r = 0; r < rowCount; r++) {
      result.push(perColumn.map((list, i) => {
        const t = list[r];
        if (!t) {
          return null;
        }
        const value = this.calculateExportTotal(dataGrid, t, rows);
        if (value == null) {
          return null;
        }
        const col = columns[i];
        const currency = this.isCurrencyFormat(col?.format) || this.isCurrencyFormat(t.valueFormat);
        const displayFormat = typeof t.displayFormat === 'string' && t.displayFormat.includes('{0}') ? t.displayFormat : '{0}';
        const numberText = currency
          ? new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value) + ' ₺'
          : new Intl.NumberFormat('tr-TR', {maximumFractionDigits: 8}).format(value);
        return {value, text: displayFormat.replace('{0}', numberText), plain: displayFormat === '{0}'};
      }));
    }
    return result;
  }

  private calculateExportTotal(dataGrid: any, totalItem: any, rows: any[]): number | null {
    const type = String(totalItem.summaryType ?? '').toLowerCase();
    if (type === 'count') {
      return rows.length;
    }
    if (!['sum', 'avg', 'min', 'max'].includes(type)) {
      // custom vb.: gridin kendi hesapladığı değeri kullan
      try {
        const v = dataGrid?.getTotalSummaryValue?.(totalItem.name ?? totalItem.column);
        return typeof v === 'number' && isFinite(v) ? v : null;
      } catch {
        return null;
      }
    }
    const values = rows
      .map((row: any) => row?.[totalItem.column])
      .filter((v: any) => v !== null && v !== undefined && v !== '' && isFinite(Number(v)))
      .map((v: any) => Number(v));
    if (type === 'sum') {
      return Number(values.reduce((a, b) => a + b, 0).toFixed(8));
    }
    if (!values.length) {
      return null;
    }
    if (type === 'avg') {
      return Number((values.reduce((a, b) => a + b, 0) / values.length).toFixed(8));
    }
    return type === 'min' ? Math.min(...values) : Math.max(...values);
  }

  /** Gruplu gridde dataSource.items() grup nesneleri döner; toplam için veri satırlarına indir. */
  private flattenExportItems(items: any[]): any[] {
    const out: any[] = [];
    (items ?? []).forEach((item: any) => {
      if (item && Array.isArray(item.items) && 'key' in item) {
        out.push(...this.flattenExportItems(item.items));
      } else {
        out.push(item);
      }
    });
    return out;
  }

  private saveWorkbook(workbook: Workbook, fileName: string): Promise<void> {
    return workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName);
    });
  }

  async onExporting(e: any): Promise<void> {
    if (e.format === 'pdf') {
      const dataGrid = e.component;
      const items = await this.getExportItems(dataGrid);
      const visibleColumns = this.getExportColumns(dataGrid);

      const columns = visibleColumns.map((col: any) => col.caption);
      const rows = items.map(
        (row: any) =>
        visibleColumns.map((col: any) => {

          const value = row[col.dataField];

          if (value == null) {
            return '';
          }

          if(col?.format == CURRENCY_FORMAT){
            return new Intl.NumberFormat('tr-TR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(value) + ' ₺';
          }
          return value;

        }
        )
      );

      const charWidth = 2.2;
      const minWidth = 20;
      const maxWidth = 70;
      const columnWidths: number[] = [];

      visibleColumns.forEach((col: any) => {
        let maxLen = (col.caption || '').length;

        items.forEach((row: any) => {
          const cellData = row[col.dataField];
          if (cellData) {
            const len = String(cellData).length;
            if (len > maxLen) maxLen = len;
          }
        });

        const estimatedWidth = Math.min(Math.max(maxLen * charWidth, minWidth), maxWidth);
        columnWidths.push(estimatedWidth);
      });

      const tempPortrait = new jsPDF({orientation: 'portrait', unit: 'mm', format: 'a4'});
      const tempLandscape = new jsPDF({orientation: 'landscape', unit: 'mm', format: 'a4'});

      const margins = {left: 5, right: 5};
      const portraitWidth = tempPortrait.internal.pageSize.getWidth() - margins.left - margins.right;
      const landscapeWidth = tempLandscape.internal.pageSize.getWidth() - margins.left - margins.right;

      const totalWidth = columnWidths.reduce((a, b) => a + b, 0);

      let orientation: 'portrait' | 'landscape';
      let pageWidth: number;

      if (totalWidth <= portraitWidth) {
        orientation = 'portrait';
        pageWidth = portraitWidth;
      } else if (totalWidth <= landscapeWidth) {
        orientation = 'landscape';
        pageWidth = landscapeWidth;
      } else {
        orientation = 'landscape';
        pageWidth = landscapeWidth;
      }

      const zoomRatio = pageWidth / totalWidth;

      const zoomedColumnWidths = columnWidths.map((w) => w * zoomRatio);
      const columnStyles: any = {};
      zoomedColumnWidths.forEach((w, i) => {
        columnStyles[i] = {cellWidth: w};
      });

      const fontSize = zoomRatio < 1 ? 8 * zoomRatio : 8;

      const doc = new jsPDF({
        orientation: orientation,
        unit: 'mm',
        format: 'a4',
      });

      doc.addFileToVFS('Arial.ttf', ArialBase64);
      doc.addFont('Arial.ttf', 'ArialBase64Custom', 'normal');
      doc.setFont('ArialBase64Custom');

      // DKM-5296: grid alt toplamları PDF'in son sayfasına alt satır olarak
      const footRows = this.getExportTotalRows(dataGrid, visibleColumns, items).map((totalRow, r) =>
        totalRow.map((cell, i) => {
          if (cell) {
            return {content: cell.text, styles: {halign: 'right'}};
          }
          return r === 0 && i === 0 ? 'Toplam' : '';
        }));

      autoTable(doc, {
        head: [columns],
        body: rows,
        ...(footRows.length ? {
          foot: footRows as any,
          showFoot: 'lastPage' as const,
          footStyles: {fillColor: [235, 235, 235], textColor: 20},
        } : {}),
        styles: {
          font: 'ArialBase64Custom',
          fontSize: fontSize,
          cellPadding: 2,
          overflow: 'linebreak',
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: 20,
        },
        theme: 'grid',
        startY: 5,
        margin: {
          top: 10,
          left: margins.left,
          right: margins.right,
          bottom: 5,
        },
        columnStyles,
      });

      doc.save('grid.pdf');
    } else {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('grid');
      e.cancel = true;

      if (this.gridCtlList?.pageCount === 0) {
        // Virtual scrolling'de exportDataGrid sadece yüklü satırları (50) aktarıyor;
        // tüm kayıtları kendimiz çekip worksheet'e yazıyoruz.
        const dataGrid = e.component;
        const items = await this.getExportItems(dataGrid);
        const visibleColumns = this.getExportColumns(dataGrid);

        worksheet.columns = visibleColumns.map((col: any) => ({
          header: col.caption,
          key: col.dataField,
          width: Math.min(Math.max((col.caption || '').length + 2, 12), 60)
        }));
        worksheet.getRow(1).font = {bold: true};
        worksheet.autoFilter = {
          from: {row: 1, column: 1},
          to: {row: 1, column: Math.max(visibleColumns.length, 1)}
        };

        items.forEach((row: any) => {
          worksheet.addRow(visibleColumns.map((col: any) => row[col.dataField] ?? null));
        });

        // DKM-5296: grid alt toplamlarını verinin altına yaz (exportDataGrid yolu bunu kendisi yapıyor)
        this.getExportTotalRows(dataGrid, visibleColumns, items).forEach((totalRow, r) => {
          const excelRow = worksheet.addRow(totalRow.map((cell, i) => {
            if (cell) {
              return cell.plain ? cell.value : cell.text;
            }
            return r === 0 && i === 0 ? 'Toplam' : null;
          }));
          excelRow.font = {bold: true};
        });

        visibleColumns.forEach((col: any, i: number) => {
          if (this.isCurrencyFormat(col?.format)) {
            worksheet.getColumn(i + 1).numFmt = CURRENCY_EXCEL_FORMAT;
          }
        });

        await this.saveWorkbook(workbook, 'DataGrid.xlsx');
        return;
      }

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
          customizeCell: ({ gridCell, excelCell }) => {
            const column = gridCell.column
            if(this.isCurrencyFormat(column?.format)){
              excelCell.numFmt = CURRENCY_EXCEL_FORMAT;
            }
          }
      }).then(() => this.saveWorkbook(workbook, 'DataGrid.xlsx'));
    }
  }

  /**
   * Para kolonlarında Excel biçimini kendimiz veriyoruz. DevExtreme, 'currency'
   * tipi biçimi tam küçük harf değilse Excel'e ' ' (tek boşluk) biçim koduyla
   * yazıyor; hücrede değer duruyor ama boş görünüyor.
   */
  isCurrencyFormat(format: any): boolean {
    if (typeof format === 'string') {
      return format === CURRENCY_FORMAT || format.toLowerCase() === 'currency';
    }
    return typeof format?.type === 'string' && format.type.toLowerCase() === 'currency';
  }

  closedPopover() {
    this.showAttributes = false;
    this.gridListCtlNew = null;
  }

  eventHandlerTercihler(e: any) {
    this.gridListCtlNew = this.gridCtlList;
    this.showTarget = e.event.currentTarget;
    this.showAttributes = true;
  }

  onTercihPopupHidden() {
    this.showAttributes = false;
  }

  // DKM-5344 Clara: Liste ayarlarını kaydet / resetle düğmeleri araç çubuğundan Tercihler popup'ının altına taşındı.
  /** Tercihler popup'ındaki "Liste Ayarlarını Kaydet" açıklaması (role göre kaydın kimi etkilediği). */
  get listeAyarKaydetAciklama(): string {
    if (this.userListEditRole === 'DaBAdmin') return 'Kolon sırası, genişlik ve başlıklar tüm kurumlar için varsayılan olur (DaBAdmin).';
    if (this.userListEditRole === 'ListAdmin') return 'Kolon sırası, genişlik ve başlıklar bu kurumdaki tüm kullanıcılar için kaydedilir (ListAdmin).';
    return 'Kolon sırası, genişlik ve başlıklar yalnız sizin için kaydedilir.';
  }

  /** Tercihler popup'ındaki "Liste Ayarlarını Resetle" açıklaması. */
  get listeAyarResetAciklama(): string {
    if (this.userListEditRole === 'ListAdmin') return 'Bu kurum için kaydedilmiş liste ayarları silinir, varsayılan düzene dönülür (ListAdmin).';
    return 'Kaydettiğiniz kişisel liste ayarları silinir, varsayılan düzene dönülür.';
  }

  tercihListeAyarKaydet() {
    this.closedPopover();
    this.handleGridSettingSaveBtn();
  }

  tercihListeAyarResetle() {
    this.closedPopover();
    this.handleResetGridSettingSaveBtn();
  }

  showSelectModule() {
    this.showAttributes = true;
  }

  xselectionChangedHandler($event: any) {
    this.selectedRowData.emit($event);
    this.selectionChangedBySelectbox = false;
    //
  }

  // defaultSelectedFirstItem(e:any){
  //   if (!e.component.getSelectedRowKeys().length && this.defaultSelectFirstItem) { e.component.selectRowsByIndexes(0); }
  //
  // }

  focusedRowIndexChange($event: number) {
    this.focusedRowIndexNumber.emit($event);
    // if($event == -1 ){
    //   this.focusedRowChanged.emit(null)
    // }
  }

  onInitNewRow(e: any) {
    this.onInitNewRowEmit.emit(e);
    if (this.defaultValues) {
      Object.keys(this.defaultValues).forEach((key) => {
        e.data[key] = this.defaultValues[key];
      });
    }

    if (this.gridCtlList?.editMode === 'form') {
      this.formEditRowData = structuredClone(e.data);
    }
  }

  otherActionClicked = (button: any, data: any) => {
    //işlemler butonunun içinde normal buton
    this.clickOtherBtn.emit({
      button,
      rowData: data.row.data,
      buttonPosition: data.event.currentTarget,
      target: data.element.attributes.id.nodeValue,
      row: data.row,
    });
  };

  // otherActionClicked() {
  //   //this.clickOtherBtn.emit({button, rowData: data.row})
  //
  // }

  contextMenu($event: any) {
    this.rightClicked.emit($event);
  }

  contextMenuRightClick(e: any) {
    this.selectedRowData.emit(e.row);
    // if (this.isListEditAdmin) {
      // DKM-5344 Clara: eski hâli — e.target 'header' filtre satırını (rowType 'filter') da kapsıyordu; arama kutusunda sağ tık
      // "Başlığı Düzenle" menüsünü açıp tarayıcının kopyala/yapıştır menüsünü engelliyordu.
      // if (e.target === 'header') {
      // Yalnız başlık satırında ekle; filtre satırında e.items boş kalır, DevExtreme menüyü açmaz, tarayıcı menüsü çıkar.
      if (e.target === 'header' && e.row?.rowType === 'header') {
        e.items = e.items || [];

        e.items.push({
          text: 'Başlığı Düzenle',
          onItemClick: () => {
            this.editColumnCaption(e.column);
          }
        });
      }
    // }

  }

  editColumnCaption(column: any) {
    this.editingColumnField = column.dataField;
    this.captionEditText = column.caption || column.dataField;
    this.editCaptionPopupVisible = true;
  }

  cancelCaptionEdit() {
    this.editCaptionPopupVisible = false;
    this.captionEditText = '';
    this.editingColumnField = '';
  }


  applyCaptionChange() {
    const trimmedCaption = this.captionEditText.trim();

    if (this.editingColumnField && trimmedCaption) {
      this.dataGrid.instance.columnOption(this.editingColumnField, {
        caption: trimmedCaption
      });

      // sadece popup'ı kapat
      this.editCaptionPopupVisible = false;
      this.captionEditText = '';
      this.editingColumnField = '';
    }
  }


  clickMenuButtonActions($event: any) {
    //işlemler butonu hambuger menü içinde
    if ($event.itemData.name === 'History') {
      this.historyPopupVisible = true;
      this.setHistoryFilterData(this.actionSheetRowData);
    }
    this.clickMenuButton.emit({
      button: $event.itemData,
      rowData: this.actionSheetRowData,
    });
  }

  setHistoryFilterData(data: any) {
    this.historyFilterData = {
      Donem: data?.Donem,
      Kod: this.historyGetCode ? this.historyGetCode : data?.Kod,
      kayitAdi: this.gridCtlList?.historyEntity,
      kaydedenKod: data?.KayitKullaniciKod,
      kayitTarih: data?.KayitTarih,
      sonDegistirenKod: data?.DegisKullaniciKod,
      degisiklikTarih: data?.DegisTarih,
    };
  }

  onHistoryPopupHidden() {
    this.historyPopupVisible = false;
  }

  // sadece dusuk boyutlu dataalrda kullanılıyor
  calculateCustomSummary1 = (options: any) => {
    if (
      options.summaryProcess &&
      this.sumListItems.some((item) => item.name === options.name)
    ) {
      if (options.summaryProcess === 'start') {
        options.totalValue = 0;
      }

      if (options.summaryProcess === 'calculate') {
        const isRowSelected = options.component.isRowSelected(
          options.value?.Kod
        );

        if (isRowSelected) {
          for (const sumItem of this.sumListItems) {
            options.totalValue += options.value[sumItem.column];
          }
        }
      }
    }
  };

  // DKM-5052 Clara: işaretli satır sayısı (pager bilgi metninde gösterilir; 0 iken metin değişmez)
  // Etki alanı: tüm dk-dx-data-table2 gridleri (keepSelectionOnFilter'dan bağımsız); fark yalnız seçim kolonu açık gridlerde görünür.
  seciliSatirSayisi = 0;
  private pagerSecimMetniKullanildi = false;

  get pagerInfoTextGorunen(): string | undefined {
    const temel = this.pagerInfoText ? this.pagerInfoText + ' Sayfa {0} / {1} ({2} Veri)' : undefined;
    if (!this.seciliSatirSayisi) {
      // Hiç seçim yapılmamış gridde bağlama eskisi gibi undefined kalır (DevExtreme varsayılanı).
      // Seçim bir kez gösterildiyse undefined'a dönmek pager'ı eski "· n seçili" metninde bırakıyor → varsayılanı açıkça ver.
      return temel ?? (this.pagerSecimMetniKullanildi ? formatMessage('dxPager-infoText') : undefined);
    }
    this.pagerSecimMetniKullanildi = true;
    return (temel ?? formatMessage('dxPager-infoText')) + ' · ' + this.seciliSatirSayisi + ' seçili';
  }

  async selectionChangedHandler(e: DxDataGridTypes.SelectionChangedEvent) {
    //await e.component.refresh(false);
    this.seciliSatirSayisi = e.selectedRowKeys?.length ?? 0; // DKM-5052 Clara
    this.selectedRowData.emit(e);
    this.selectionChangedBySelectbox = false;
  }

  clearHeaderFilter() {
    this.dataGrid?.instance?.clearFilter('row');
    this.dataGrid?.instance?.clearSelection()
    // this.dataGrid.instance.state(null)
  }

  logSelectedFilter($event: any) {
  }

  // logExportData($event: {
  //   allowExportSelectedData?: boolean;
  //   enabled?: boolean;
  //   formats?: Array<DataGridExportFormat | string>;
  //   texts?: { exportAll?: string; exportSelectedRows?: string; exportTo?: string }
  // }) {
  //
  // }


  handleTableHeaderDynamicButtonClick(dynamicButton: any) {
    this.dynamicTableHeaderButtonClicked.emit(dynamicButton);
  }

  switchButtonChanged($event: ValueChangedEvent) {
    this.switchButtonResult.emit($event.value);
    //this.batchEditing=$event.value
  }

  customHeaderSwitchButtonChanged($event:ValueChangedEvent){
    this.customHeaderSwitchButtonValueResult.emit($event.value);
  }


  onRowPrepared(e: any) {
    if(this.editFormTemplate !== undefined){
      if (e.rowType !== 'data') return;

      if (e.isEditing) {
        e.rowElement.style.height = 'auto';

        const cells = e.rowElement.querySelectorAll('td');
        cells.forEach((td: HTMLElement) => {
          td.style.verticalAlign = 'top';
        });
      }
    }
    // 🔹 1. Row color condition
    if (this.rowColorCondition) {
      this.rowColorCondition.forEach(x => {
        if (e.rowType === 'data') {
          const conditionValue = e.data[x.conditionColName];
          const conditionSymbol = x.conditionColSymbol;
          const conditionText = this.bothConditionAreField
            ? e.data[x.conditionColText]
            : x.conditionColText;

          const isConditionMet = this.evaluateCondition(conditionValue, conditionSymbol, conditionText);

          if (isConditionMet || e.rowIndex === this.emphasizeRowIndex) {
            e.rowElement.style.color = x.conditionRowColor;
          }
        }
      });
    }

    // 🔹 2. Row style condition (CSS)
    if (this.rowStyleCondition) {
      this.rowStyleCondition.forEach(x => {
        if (e.rowType === 'data') {
          const conditionValue = e.data[x.conditionColName];
          const conditionSymbol = x.conditionColSymbol;
          const conditionText = this.bothConditionAreField
            ? e.data[x.conditionColText]
            : x.conditionColText;

          const isConditionMet = this.evaluateCondition(conditionValue, conditionSymbol, conditionText);

          if (isConditionMet || e.rowIndex === this.emphasizeRowIndex) {
            const styleProps = x.conditionRowStyle;
            const styleValues = x.conditionRowStyleValue;

            // Zebra desenini engelle
            e.rowElement.classList.remove('dx-row-alt');

            if (styleProps?.length === styleValues?.length) {
              for (let i = 0; i < styleProps.length; i++) {
                const styleName = styleProps[i];
                const styleValue = styleValues[i];

                if (typeof styleValue === 'string' && styleValue.includes('!important')) {
                  const pureValue = styleValue.replace('!important', '').trim();
                  const kebabStyleName = styleName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                  e.rowElement.style.setProperty(kebabStyleName, pureValue, 'important');
                } else {
                  (e.rowElement.style as any)[styleName] = styleValue;
                }
              }
            } else {
              console.warn("Style ve değer listelerinin uzunluğu eşleşmiyor:", styleProps, styleValues);
            }
          }
        }
      });
    }

    // 🔹 3. Column style condition (sadece data hücreleri için)
    if (this.columnStyleCondition && e.rowType === 'data' && Array.isArray(e.columns)) {
      this.columnStyleCondition.forEach(condition => {
        e.columns.forEach((column: any, index: number) => {
          const dataField = column?.dataField;
          if (this.checkFieldNames(condition.fieldNames, dataField)) {
            const cellElement = e.rowElement?.children?.[index];
            if (!cellElement) return;

            const styleProps = condition.conditionColumnStyle;
            const styleValues = condition.conditionColumnStyleValue;

            if (styleProps?.length === styleValues?.length) {
              for (let i = 0; i < styleProps.length; i++) {
                const styleName = styleProps[i];
                const styleValue = styleValues[i];

                if (typeof styleValue === 'string' && styleValue.includes('!important')) {
                  const pureValue = styleValue.replace('!important', '').trim();
                  const kebabStyleName = styleName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                  cellElement.style.setProperty(kebabStyleName, pureValue, 'important');
                } else {
                  (cellElement.style as any)[styleName] = styleValue;
                }
              }
            } else {
              console.warn("Column style/value eşleşmiyor:", styleProps, styleValues);
            }
          }
        });
      });
    }

    // 🔹 Event emit
    this.rowPrepared.emit(e);
  }


  onCellPrepared(e: any) {
    if (e.rowType === 'header' && this.headerStyleCondition) {
      this.headerStyleCondition.forEach(condition => {
        const dataField = e.column?.dataField || e.column?.caption;

        if (this.checkFieldNames(condition.fieldNames, dataField)) {
          const cellElement = e.cellElement;
          if (!cellElement) return;

          const textElement = cellElement.querySelector('.dx-datagrid-text-content');
          const styleProps = condition.conditionRowStyle;
          const styleValues = condition.conditionRowStyleValue;

          if (styleProps?.length === styleValues?.length) {
            for (let i = 0; i < styleProps.length; i++) {
              const styleName = styleProps[i];
              const styleValue = styleValues[i];
              const kebabStyleName = styleName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

              // 🔹 TD ve içteki metin div’ine uygula
              cellElement.style.setProperty(kebabStyleName, styleValue, 'important');
              if (textElement) {
                textElement.style.setProperty(kebabStyleName, styleValue, 'important');
              }
            }
          } else {
            console.warn("Header style/value eşleşmiyor:", styleProps, styleValues);
          }
        }
      });
    }
  }




  // onRowPrepared(e: any) {
  //   // if (e.rowType === 'data' && this.rowColorFor.field){
  //   //   e.rowElement.style.borderBottomColor = 'gray'
  //   // }
  //
  //
  //   if (this.rowColorCondition) {
  //
  //     //this.emphasizeRow
  //
  //     this.rowColorCondition.map(x => {
  //       if (e.rowType === 'data') {
  //         const conditionValue = e.data[x.conditionColName];
  //         const conditionSymbol = x.conditionColSymbol;
  //         let conditionText;
  //         if (this.bothConditionAreField) {
  //           conditionText = e.data[x.conditionColText];
  //         } else {
  //           conditionText = x.conditionColText;
  //         }
  //
  //         const isConditionMet = this.evaluateCondition(conditionValue, conditionSymbol, conditionText);
  //
  //         if (isConditionMet || (e.rowIndex === this.emphasizeRowIndex)) {
  //           e.rowElement.style.color = x.conditionRowColor;
  //         }
  //
  //       }
  //
  //
  //     })
  //   }
  //
  //
  //   if (this.rowStyleCondition) {
  //     this.rowStyleCondition.forEach(x => {
  //       if (e.rowType === 'data') {
  //         const conditionValue = e.data[x.conditionColName];
  //         const conditionSymbol = x.conditionColSymbol;
  //         let conditionText;
  //
  //         if (this.bothConditionAreField) {
  //           conditionText = e.data[x.conditionColText];
  //         } else {
  //           conditionText = x.conditionColText;
  //         }
  //
  //         const isConditionMet = this.evaluateCondition(conditionValue, conditionSymbol, conditionText);
  //
  //         if (isConditionMet || (e.rowIndex === this.emphasizeRowIndex)) {
  //           const styleProps = x.conditionRowStyle;
  //           const styleValues = x.conditionRowStyleValue;
  //
  //           // Zebra desenini engelle
  //           e.rowElement.classList.remove('dx-row-alt');
  //
  //           if (styleProps?.length === styleValues?.length) {
  //             for (let i = 0; i < styleProps.length; i++) {
  //               const styleName = styleProps[i];
  //               let styleValue = styleValues[i];
  //
  //               if (typeof styleValue === 'string' && styleValue.includes('!important')) {
  //                 const pureValue = styleValue.replace('!important', '').trim();
  //                 const kebabStyleName = styleName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  //                 e.rowElement.style.setProperty(kebabStyleName, pureValue, 'important');
  //               } else {
  //                 (e.rowElement.style as any)[styleName] = styleValue;
  //               }
  //             }
  //           } else {
  //             console.warn("Style ve değer listelerinin uzunluğu eşleşmiyor:", styleProps, styleValues);
  //           }
  //         }
  //       }
  //     });
  //   }
  //
  //   if (e.rowType === 'header' && this.headerStyleCondition && Array.isArray(e.columns)) {
  //     this.headerStyleCondition.forEach(condition => {
  //       e.columns.forEach((column: any, index: number) => {
  //         const dataField = column?.dataField;
  //         if (this.checkFieldNames(condition.fieldNames, dataField)) {
  //           const cellElement = e.rowElement?.children?.[index];
  //           if (!cellElement) return;
  //
  //           const styleProps = condition.conditionRowStyle;
  //           const styleValues = condition.conditionRowStyleValue;
  //
  //           if (styleProps?.length === styleValues?.length) {
  //             for (let i = 0; i < styleProps.length; i++) {
  //               const styleName = styleProps[i];
  //               let styleValue = styleValues[i];
  //
  //               if (typeof styleValue === 'string' && styleValue.includes('!important')) {
  //                 const pureValue = styleValue.replace('!important', '').trim();
  //                 const kebabStyleName = styleName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  //                 cellElement.style.setProperty(kebabStyleName, pureValue, 'important');
  //               } else {
  //                 (cellElement.style as any)[styleName] = styleValue;
  //               }
  //             }
  //           } else {
  //             console.warn("Header style/value eşleşmiyor:", styleProps, styleValues);
  //           }
  //         }
  //       });
  //     });
  //   }
  //
  //
  //   this.rowPrepared.emit(e);
  //
  //
  //   // if (e.rowType === 'data' && e.data[this.rowColorFor?.field]) {
  //   //   //e.rowElement.classList.add('custom-background-class');
  //   //   e.rowElement.style.color = this.rowColorFor.color;
  //   //   // e.rowElement.classList.add('custom-background-class');
  //   //   // e.rowElement.style.setProperty('background-color', this.rowColorFor.color, 'important');
  //   // }
  // }

  checkFieldNames(fieldNames: string[], dataField: string): boolean {
    return fieldNames?.includes('All') || fieldNames?.includes(dataField);
  }

  onselectedRowKeysChange(e: any[]) {
    this.selectedRowKeysChange.emit(e)
  }


  evaluateCondition(value: any, operator: string, compareTo: any): boolean {
    const isNumberOperator = ['<', '<=', '>', '>='].includes(operator);

    // Hem value hem compareTo undefined/null ise özel karşılaştırma yapalım
    if (value === undefined || value === null || compareTo === undefined || compareTo === null) {
      switch (operator) {
        case '==':
          return value == compareTo;
        case '===':
          return value === compareTo;
        case '!=':
          return value != compareTo;
        case '!==':
          return value !== compareTo;
        default:
          return false; // Sayısal operatörlerde NaN ile uğraşmayalım
      }
    }

    // Sayısal karşılaştırma gerekiyorsa sayıya çevir
    const val = isNumberOperator ? Number(value) : value;
    const cmp = isNumberOperator ? Number(compareTo) : compareTo;

    // Sayısal karşılaştırma ama değerler sayı değilse geçersiz say
    if (isNumberOperator && (isNaN(val) || isNaN(cmp))) {
      console.warn(`Sayı karşılaştırması yapılamıyor:`, value, compareTo);
      return false;
    }

    // Karşılaştırma işlemleri
    switch (operator) {
      case '==':
        return val == cmp;
      case '===':
        return val === cmp;
      case '!=':
        return val != cmp;
      case '!==':
        return val !== cmp;
      case '<':
        return val < cmp;
      case '<=':
        return val <= cmp;
      case '>':
        return val > cmp;
      case '>=':
        return val >= cmp;
      default:
        console.error(`Desteklenmeyen karşılaştırma operatörü: ${operator}`);
        return false;
    }
  }


  onDataErrorOccurred(e: any) {
    let rawError = e.error;
    // İsteğe bağlı: Başka bir yere emit etme
    this.validationErrorMessage.emit(rawError);
  }

  simplifyError(error: any): string {
    let parsedError: any;
    let simplifiedMessage = 'Bir hata oluştu, lütfen tekrar deneyin.';
    try {
      if (error instanceof HttpErrorResponse) {
        parsedError = typeof error.error === 'string' ? JSON.parse(error.error) : error.error;
      } else if (typeof error === 'string') {
        parsedError = JSON.parse(error);
      } else if (error?.message && typeof error.message === 'string') {
        parsedError = JSON.parse(error.message);
      } else {
        parsedError = error;
      }

      if (parsedError?.Error?.Details?.length > 0) {
        simplifiedMessage = parsedError.Error.Details.map((d: any) => d.Message).join(' | ');
      } else if (parsedError?.Error?.Message) {
        simplifiedMessage = parsedError.Error.Message;
      }
    } catch {
      // JSON parse hatası varsa varsayılan mesaj kalır
    }

    return simplifiedMessage;
  }


  isMatchWholeWord(column: ColumnModel, checkValue: string): boolean {
    if (new RegExp((`(^|[\\s,])${checkValue}([\\s,]|$)`)).test(column.summaryType)) {
      return true;
    } else {
      return false;
    }
  }

  onOptionChangedFunc(e: any) {
    // DKM-5052 Clara: varsayılan davranış eskisi gibi — sıralama/filtre değişince odakla birlikte seçim de temizlenir
    // (bazı formlarda seçimin silinmesi gerekiyor, dtokgoz 03.10). Yalnız [keepSelectionOnFilter]="true" geçen
    // gridlerde (şimdilik BYS Gönderim Onayı > Gönderilenler) işaretli satırlar korunur, sadece odak sıfırlanır.
    if (e.fullName.includes('sortOrder')) {
      if (this.dataGrid.instance.option("focusedRowKey") != null) {
      // DKM-5052 Clara: eski hâli
      // this.dataGrid.instance.clearSelection();
      if (!this.keepSelectionOnFilter) this.dataGrid.instance.clearSelection();
      this.dataGrid.instance.option("focusedRowIndex", -1);
      this.dataGrid.instance.option("focusedRowKey", null);
    }

    }
    if (e.fullName.includes('filterValue')) {
      this.gridFilterChanged.emit(e);
      if (this.dataGrid.instance.option("focusedRowKey") != null) {
        // DKM-5052 Clara: eski hâli
        // this.dataGrid.instance.clearSelection();
        if (!this.keepSelectionOnFilter) this.dataGrid.instance.clearSelection();
        this.dataGrid.instance.option("focusedRowIndex", -1);
        this.dataGrid.instance.option("focusedRowKey", null);
      }
    }

    if (e.fullName.includes('groupIndex')) {
      if (this.checkIfGrouped()) {
        this.autoNavigateToFocusedRow = false;
      } else {
        this.autoNavigateToFocusedRow = true;
      }
    }

  }

  checkIfGrouped(): boolean {
    const columns = this.dataGrid.instance.getVisibleColumns();
    const isGrouped = columns.some(c => typeof c.groupIndex === 'number' && c.groupIndex >= 0);
    return isGrouped;
  }

  focusFirstRow() {
    if (this.batchEditing) return;

    if (this.dataGrid && this.dataGrid.instance.getVisibleRows().length > 0) {
      this.focusedRowIndex = 0;
      this.dataGrid.instance.option('focusedRowIndex', 0);
    }else{
      this.focusedRowChanged.emit(null);
    }
  }

  clearGridFocus(){
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.option("focusedRowIndex", -1);
    this.dataGrid.instance.option("focusedRowKey", null);
  }

  contentReady(e: ContentReadyEvent) {
    this.onContentReady.emit(e);
    // DKM-5052 Clara: dataSource değişimi gibi selectionChanged tetiklemeyen sıfırlamalarda sayaç eşitlensin
    const seciliSayi = (e.component as any)?.getSelectedRowKeys?.()?.length ?? 0;
    if (seciliSayi !== this.seciliSatirSayisi) this.seciliSatirSayisi = seciliSayi;


    const gridElement = e.element as HTMLElement;

    // 🔹 Header hücrelerinin tabindex'lerini -1 yap
    const headerCells = gridElement.querySelectorAll('.dx-header-row td[tabindex], .dx-header-row th[tabindex]');
    headerCells.forEach((cell) => ((cell as HTMLElement).tabIndex = -1));

    // 🔹 Filter input'ları tab ile erişilebilir, iconlar tab sırasından çıksın
    const filterFocusableElements = gridElement.querySelectorAll('.dx-datagrid-filter-row [tabindex]');
    filterFocusableElements.forEach((el) => {
      const elem = el as HTMLElement;
      if (elem.tagName !== 'INPUT') elem.tabIndex = -1;
    });

    // 🔹 Toolbar içindeki gereksiz öğeleri tab sırasından çıkar
    if (this.focusSearchBar) {
      const toolbar = gridElement.querySelector('.dx-toolbar') || gridElement.querySelector('.dx-datagrid-toolbar');
      toolbar?.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach((n) => {
        const el = n as HTMLElement;
        if (el.closest('.dx-datagrid-search-panel')) return;
        el.tabIndex = -1;
      });

      const searchInput = this.dataGrid?.instance
        ?.element()
        .querySelector('.dx-datagrid-search-panel input') as HTMLInputElement;
      setTimeout(() => searchInput?.focus(), 300);
      this.focusSearchBar = false;
    }

      //GENERİC FOCUS
      const gridInstance = this.dataGrid?.instance;
      const focusedRowKey = gridInstance?.option('focusedRowKey');
      const focusedRowIndex = gridInstance?.option('focusedRowIndex');
      const hasEditData = gridInstance?.hasEditData?.() ?? false;

      if (
        this.dataSource != null &&
        !this.batchEditing &&
        focusedRowKey == null &&
        (focusedRowIndex == null || focusedRowIndex < 0) &&
        !hasEditData
      ) {
        this.focusFirstRow();
      }

      if(this.dataSource != null && this.dataGrid?.instance?.option('focusedRowKey') != null && this.dataGrid?.instance?.getVisibleRows()?.length == 0 ){
        this.clearGridFocus();
        this.focusedRowChanged.emit(null);
      }
      if(this.dataSource == null && this.dataGrid?.instance?.option('focusedRowKey') != null){
        this.clearGridFocus();
        this.focusedRowChanged.emit(null);
      }


      this.gridContainer = this.el.nativeElement.querySelector('.dx-datagrid');
      if(this.gridCtlList?.allowFilterYn && this.gridCtlList?.showFilterYn &&
        this.gridContainer && !this.gridContainer?.dataset?.listenerAttached
      ){
        this.gridContainer?.addEventListener('click', this.gridClickHandler);
        this.gridContainer.dataset.listenerAttached = 'true';
      }

  }


  setFilterOption(){

      if((event.target as Element).matches('li.dx-menu-item-wrapper') ){
      const wrapper = event.target as Element;
      const myElement:Element | null = wrapper.firstElementChild

      myElement?.classList.add('pointer-events-all');
      (myElement as HTMLElement).click();
      setTimeout(() => myElement?.classList.remove('pointer-events-all'), 1500);

    }

  }

  onRowInsertingFunc(e: RowInsertingEvent) {

    // Extend edilen öğeleri kaldır, aksi halde oracle hatası geliyor.
    Object.keys(e.data).forEach((key) => {
      if (typeof e.data[key] === 'object' && !(e.data[key] instanceof Date)) {
        delete e.data[key];
      }
    });
    this.onRowInserting.emit(e);

  }

  onRowInsertedFunc(e: RowInsertedEvent) {
    if(e?.key){
      this.navigateRowKey = e.key;
      this.dataGrid?.instance.navigateToRow(e.key);
      this.dataGrid.instance.option("focusedRowKey", e.key);
      this.dataGrid.instance.option("focusedRowIndex", this.dataGrid.instance.getRowIndexByKey(e.key));
    }
  }

  onRowUpdatingFunc(e: RowUpdatingEvent) {
    this.onRowUpdating.emit(e);
  }

  onRowRemovingFunc(e: RowRemovingEvent) {
    this.onRowRemoving.emit(e);
    // if (this.editingMode === 'batch') {
    //   e.cancel = true;
    //   confirm("Bu satırı silmek istediğinize emin misiniz?", "Uyarı").then(result => {
    //     if (result) {
    //       const grid = e.component as any// veya tip genişletmeli haliyle
    //       const rowIndex = e.key;
    //       grid.removeRow(rowIndex)
    //     }
    //   });
    // }
  }

  // onRowValidatingFunc(e: any) {
  //   if (this.setUniqField) {
  //     const field = this.setUniqField; // Örn: "Yil"
  //     const newValue = e.newData[field] ?? e.oldData?.[field];
  //
  //     if (!newValue) return; // Boşsa kontrol etme
  //
  //     const currentKod = e.oldData?.Kod; // Edit sırasında olur, insert'te undefined olur
  //
  //     const duplicate = this.dataSource.items().some((item: any) =>
  //       item[field] === newValue &&
  //       (currentKod === undefined || item.Kod !== currentKod)
  //     );
  //
  //     if (duplicate) {
  //       e.isValid = false;
  //       e.errorText = `Girdiğiniz ${field.toUpperCase()} (${newValue}) zaten başka bir satırda mevcut.`;
  //     }
  //   }
  // }


// DİKKAT INLINE VEYA BATCH TABLOLARDA VALİDASYON İLE UNİQ, MAX, MIN, YA DA ÖZEL bİR VALIDASYON KONTROLÜ YAPMAK İÇİN ÇAĞIRDIĞIMIZ KOMPONENETDE BU ŞEKİLDE ColumnValidationsRules eklenmeli
  // columnValidationRules = {
  //   Yil: { required: true, unique: true },
  //   Miktar: { max: 100 },
  //   Fiyat: { min: 10, max: 1000 },
  //   Açıklama: { required: true },
  //   Oran: {
  //     customValidator: (val: any) => val % 5 === 0,
  //     customMessage: 'Oran 5\'in katı olmalıdır.'
  //   }
  // };


  onRowValidatingFunc(e: any): void {
    if (!this.columnValidationRules) return;

    const updatedData = {...e.oldData, ...e.newData};

    for (const field in this.columnValidationRules) {
      const rules = this.columnValidationRules[field];
      const value = updatedData[field];

      // Required kontrolü
      if (rules.required && (value === null || value === undefined || value === '')) {
        e.isValid = false;
        e.errorText = `${field} alanı zorunludur.`;
        return;
      }

      // Min kontrolü
      if (rules.min !== undefined && value < rules.min) {
        e.isValid = false;
        e.errorText = `${field} en az ${rules.min} olabilir.`;
        return;
      }

      // Max kontrolü
      if (rules.max !== undefined && value > rules.max) {
        e.isValid = false;
        e.errorText = `${field} en fazla ${rules.max} olabilir.`;
        return;
      }

      // Benzersizlik kontrolü (unique)
      if (rules.unique) {
        const currentKod = e.oldData?.Kod;
        const duplicate = this.dataSource.items().some((item: any) =>
          item[field] === value &&
          (currentKod === undefined || item.Kod !== currentKod)
        );

        if (duplicate) {
          e.isValid = false;
          e.errorText = `Girdiğiniz ${field.toUpperCase()} (${value}) zaten başka bir satırda mevcut.`;
          return;
        }
      }

      // Özel validator kontrolü
      if (rules.customValidator && !rules.customValidator(value)) {
        e.isValid = false;
        e.errorText = rules.customMessage || `${field} değeri geçersiz.`;
        return;
      }
    }
  }


  async handleTableHeaderNewBtn(){
    // editMode === 'form' ise grid içinde yeni satır açarak custom form'u göster
    if (this.gridCtlList?.editMode === 'form') {
      if(this.unsavedChangesGuard){
        if(this.isGuardProcessing)
          return;
        this.isGuardProcessing=true;
        try{
          if(!await(this.unsavedChangesGuard())){
            this.isGuardProcessing=false;
            return;
          }
        }finally{
          this.isGuardProcessing=false;
        }
      }
      this.formEditRowData = {};
      this.dataGrid?.instance?.addRow();
      return;
    }
    this.clickAddCustomButton.emit();
  }

  onFocusedRowChangingFunc(e: any){
    if (this.setChangeWarning && e.newRowIndex !== e.prevRowIndex) {
      e.cancel = true; // Değişikliği iptal et

      confirm('Kaydetmediğiniz değişiklikler kaybolacaktır. Devam etmek istiyor musunuz?', 'Değişiklik Mevcut')
        .then((res) => {
          if (res) {
            // Bir sonraki event loop'ta odak değiştir
            setTimeout(() => {
              e.component.option('focusedRowIndex', e.newRowIndex);
            });
          }
        });
    }

  }


  onFocusedCellChangedFunc(e: any) {
    this.focusedCellChanged.emit(e);
    this.focusedRow = e?.row?.data;
    if (e.row?.rowType !== 'data') return;

    const col = e?.column;
    const field = col?.dataField ?? null;

    let editingValue: any = null;

    // Eğer hücre edit modundaysa, değeri al
    if (field) {
      editingValue = e.component.cellValue(e?.rowIndex, field);
    }

    this.focusedCell = {
      rowIndex: e?.rowIndex,
      columnIndex: e?.columnIndex,
      dataField: field,
      data: editingValue // buraya kaydediyoruz
    };
  }


  onEditingStart = (e: EditingStartEvent) => {
    // Hücreye ait satırın güncellenmesine izin verilmiyorsa
   if(this.batchEditing){
     if (this.batchEditing) {
       if (!e?.column?.dataField || !this.gridCtlList?.fields) return;

       const fieldDef = this.gridCtlList.fields.find(
         (f: any) => f.dataField === e.column.dataField
       );

       // Sadece mouse ile tıklamayı engelle (Tab: DevExtreme yerel navigasyon + allowEditing)
       if (fieldDef && fieldDef.editYn === false) {
         const rawEvent = (e as any).event;
         const isMouseAction =
           rawEvent && rawEvent.type && rawEvent.type.toLowerCase().includes('mouse');

         if (isMouseAction) {
           e.cancel = true;
         }
       }
     }
   }
  }


  getSafeDataType(type: any): DataType {
    return type as DataType;
  }

  getSafeFixedposition(position: any): HorizontalEdge {
    return position as HorizontalEdge;

  }


  handleBottomDynamicButons($event: any) {
    this.clickBottomDynamicButtons.emit($event);
  }

  async openGridSettingsPopup(listName: string) {
    // 🔹 1. Gerekli listeleri yükle (asenkron değilse beklemeye gerek yok)
    this.dListService.getDlist('GenDlists');
    this.dListService.getDlist('GenDlistColumns');

    // 🔹 2. Form metadata ve liste verilerini paralel al
    const [formMetadataGridsSetting, res] = await Promise.all([
      firstValueFrom(this.formMetadataService.getFormMetaData('GenDlistForm').pipe(take(1))),
      this.ortakService.getViewDataWithFilter('GenDlist', 'Id', [['DlistCode', '=', listName]])
    ]);

    // 🔹 3. Veri kontrolü
    if (!res || res.length === 0) {
      console.warn(`List name "${listName}" için kayıt bulunamadı.`);
      return;
    }

    // 🔹 4. Popup için setup
    this.selectedListRowWithName = { ...res[0] };
    this.gridSettingsPageVisible = true;

    setTimeout(async () => {
      const { DlistEditComponent } = await import('@dabnet-kamu/ys/components/DList/dlist-edit/dlist-edit.component');

      if (!this.gridSettingsContainer) {
        console.error('gridSettingsContainer is undefined');
        return;
      }

      this.gridSettingsContainer.clear();
      this.gridSettingsComponentRef = this.gridSettingsContainer.createComponent(DlistEditComponent);

      const metadataToUse = this.formMetaData || formMetadataGridsSetting;

      this.gridSettingsComponentRef.instance.selectedRow = this.selectedListRowWithName;
      this.gridSettingsComponentRef.instance.state = 'Edit';
      this.gridSettingsComponentRef.instance.isOpened = this.gridSettingsPageVisible;
      this.gridSettingsComponentRef.instance.dListFormMetada = metadataToUse;

      this.gridSettingsComponentRef.instance.closePopup.subscribe((event: any) => {
        this.closeGridSettingPopupAfter(event);
      });
    }, 0);
  }



  onGridSettingPopupHidden() {
    if (this.gridSettingsComponentRef) {
      this.gridSettingsComponentRef.destroy();
      this.gridSettingsComponentRef = null; // bu olmazsa tekrar açılınca component yeniden oluşmaz
    }
    this.gridSettingsPageVisible = false;
  }


  closeGridSettingPopupAfter(event: any) {
    this.onGridSettingPopupHidden();
    // Diğer işlemler...
  }

  handleGridSettingSaveBtn() {
    const state = this.getStateWithCaptions();

    confirm('Kaydetmek istiyor musunuz?', 'Liste Ayarları').then((res) => {
      if (res) {
        const save = this.dlistSaveOverride
          ? this.dlistSaveOverride(state.columns, false)
          : this.ortakService.SetDlist_Request(new SetDlist_Request({
              dListCode: this.gridCtlList?.dlistCode,
              dxColumns: state.columns,
              resetYn: false,
              rol:this.userListEditRole
            })).then((r) => r.response);

        save.then((response) => {
          if (response.result === true) {
            this.utilsService.showSuccess('Liste ayarları başarıyla güncellendi.')
            this.gridCtlList.fields = response.dListMetadata.fields
          } else {
            this.utilsService.showError(response.errorMessage)
          }
        })

      }
    });
  }

  handleResetGridSettingSaveBtn() {
    const state = this.getStateWithCaptions();

    confirm('Liste ayarlarını sıfırlamak istiyor musunuz?', 'Liste Ayarları').then((res) => {
      if (res) {
        this.ortakService.SetDlist_Request(new SetDlist_Request({
          dListCode: this.gridCtlList?.dlistCode,
          dxColumns: state.columns,
          resetYn: true,
          rol:this.userListEditRole
        })).then((res) => {
          if (res.response.result === true) {
            this.utilsService.showSuccess('Liste ayarları başarıyla güncellendi.')
            this.gridCtlList = res.response.dListMetadata
          } else {
            this.utilsService.showError(res.response.errorMessage)
          }
        })

      }
    });
  }

  getStateWithCaptions(): any {
    const state = this.dataGrid?.instance.state();

    if (state.columns) {
      // 'buttons' tipinde olan kolonları filtrele
      state.columns = state.columns
        .filter((col: any) => col.name !== 'buttons' || col.dataField !== 'İşlemler' || col.name !== 'İşlemler')
        .map((col: any) => {
          const caption = this.dataGrid.instance.columnOption(col.dataField)?.caption;
          return {
            ...col,
            caption: caption || col.caption || col.dataField
          };
        });
    }

    return state;
  }

  onDropDownSelectChanged = (e: any) => {

    this.dropDownSelectChanged.emit(e);

  }

  chevronButtonClicked($event: any) {
    this.chevronButtonClicEvent.emit($event)

  }
}
